import { getWrestlerName, getWrestlerNameUpper, wrestlerMatchesSearch, sortWrestlersByName } from './wrestlerUtils';
import React, { useState } from 'react';
import placeholder from '../assets/placeholder.png';
import placeholderTitle from '../assets/Placeholder_Title.png';
import { MATCH_TYPES, MATCH_RULES, SLOT_LABELS, SLOT_COLORS, getMatchPrice, getShowStructure, getMatchTypesForRule } from './matchTypesDatabase';
import { PROMO_ACTIONS } from './promoDatabase';
import { TITLES_DATABASE } from './titlesDatabase';
import { getClassIcon, getRoleIcon, getXPBadge } from './wrestlerIcons';
import UnifiedWrestlerCard, { WrestlerCardStyles } from './WrestlerCard';
import SuperstarPicker from './SuperstarPicker';


// Dynamic wrestler render loader
const getWrestlerRender = (w) => {
  if (!w) return null;
  if (w.customRender) return w.customRender;
  if (w.wrestler_id) return process.env.PUBLIC_URL + '/wrestlers/' + w.wrestler_id + '-render.png';
  return null;
};

const INTERFERENCE_COST = { superstar: 2000, gm: 3000 };

const PROMO_CONFIG = {
  'self-promo':      { participants: 1, hasTarget: false, targetCount: 0, label: 'PERFORMER' },
  'call-out':        { participants: 1, hasTarget: true,  targetCount: 1, label: 'CALLER', targetLabel: 'TARGET' },
  'role-change':     { participants: 1, hasTarget: false, targetCount: 0, label: 'SUPERSTAR' },
  'advertising':     { participants: 1, hasTarget: false, targetCount: 0, label: 'SUPERSTAR' },
  'charity':         { participants: 1, hasTarget: false, targetCount: 0, label: 'SUPERSTAR' },
  'class-change':    { participants: 1, hasTarget: false, targetCount: 0, label: 'SUPERSTAR' },
  'training':        { participants: 1, hasTarget: false, targetCount: 0, label: 'SUPERSTAR' },
  'tag-team-call-out': { participants: 2, hasTarget: true, targetCount: 2, isTag: true, label: 'TEAM', targetLabel: 'TARGET TEAM' },
  'invasion':        { participants: 1, hasTarget: false, targetCount: 0, hasRivalTarget: true, label: 'INVADER' },
};

const getTitleRender = (titleId) => {
  if (!titleId) return null;
  return process.env.PUBLIC_URL + '/titles/' + titleId + '-render.png';
};

const BRAND_COLORS = { 'Raw': '#c0392b', 'SmackDown': '#1a6bb5', 'NXT': '#a8a9ad', 'NXT 2.0': '#e91e8c', 'ECW': '#7b1fa2', 'WCW': '#e65100', 'NXT Mutiny': '#424242' };
const CLASS_COLORS = { 'Fighter': '#3498db', 'Bruiser': '#e74c3c', 'Cruiser': '#2ecc71', 'Specialist': '#9b59b6', 'Giant': '#e67e22' };

// Brand vertical background images — used for brand participant cards in MatchMaker
const BRAND_BG_IMAGES_BK = {
  'Raw':        process.env.PUBLIC_URL + '/brands/backgrounds/RAW_BG.png',
  'SmackDown':  process.env.PUBLIC_URL + '/brands/backgrounds/SMACKDOWN_BG.png',
  'NXT':        process.env.PUBLIC_URL + '/brands/backgrounds/NXT_BG.png',
  'NXT 2.0':    process.env.PUBLIC_URL + '/brands/backgrounds/NXT20_BG.png',
  'WCW':        process.env.PUBLIC_URL + '/brands/backgrounds/WCW_BG.png',
  'ECW':        process.env.PUBLIC_URL + '/brands/backgrounds/ECW_BG.png',
  'NXT Mutiny': process.env.PUBLIC_URL + '/brands/backgrounds/NXTMUTINY_BG.png',
};
const BRAND_LOGOS_BK_MODULE = {
  'Raw': process.env.PUBLIC_URL + '/brands/logos/RAW25_LOGO.png',
  'SmackDown': process.env.PUBLIC_URL + '/brands/logos/SMACKDOWN25_LOGO.png',
  'NXT': process.env.PUBLIC_URL + '/brands/logos/NXT_LOGO.png',
  'NXT 2.0': process.env.PUBLIC_URL + '/brands/logos/NXT20_LOGO.png',
  'WCW': process.env.PUBLIC_URL + '/brands/logos/WCW_LOGO.png',
  'ECW': process.env.PUBLIC_URL + '/brands/logos/ECW_LOGO.png',
  'NXT Mutiny': process.env.PUBLIC_URL + '/brands/logos/NXTMUTINY_LOGO.png',
};

const css = `
  * { box-sizing: border-box; }
  html { font-size: 133%; }
  .slot-card { transition: background 0.15s, border-color 0.15s, transform 0.15s; cursor: pointer; }
  .slot-card:hover { filter: brightness(1.15) !important; }
  .slot-card.selected { outline: 2px solid rgba(255,255,255,0.8) !important; }
  .btn-wwe:hover { background: rgba(255,255,255,0.1) !important; border-color: rgba(255,255,255,0.6) !important; color: #fff !important; }
  .picker-row:hover { background: rgba(255,255,255,0.07) !important; }
  .picker-row { transition: background 0.1s; cursor: pointer; }
  .superstar-slot:hover { border-color: rgba(255,255,255,0.5) !important; }
  .superstar-slot { transition: background 0.15s, border-color 0.15s, transform 0.15s; cursor: pointer; }
  ::-webkit-scrollbar { width: 4px; }
  ::-webkit-scrollbar-thumb { background: rgba(255,255,255,0.15); border-radius: 2px; }
  select option { background: #1a1a1a; color: #fff; }
`;

const S = {
  panel: { background: 'rgba(8,8,8,0.88)', border: '1px solid rgba(255,255,255,0.09)', borderRadius: '8px' },
  title: { fontFamily: "'Anton', sans-serif", letterSpacing: '3px', color: '#fff' },
  mono: { fontFamily: "'Monda', sans-serif" },
  anton: { fontFamily: "'Anton', sans-serif" },
  btn: { fontFamily: "'Monda', sans-serif", fontSize: '0.55rem', letterSpacing: '1.5px', background: 'transparent', border: '1px solid rgba(255,255,255,0.25)', color: 'rgba(255,255,255,0.6)', padding: '6px 14px', borderRadius: '4px', cursor: 'pointer', transition: 'background 0.15s, border-color 0.15s, color 0.15s' },
  input: { background: 'rgba(20,20,20,0.95)', border: '1px solid rgba(255,255,255,0.2)', borderRadius: '4px', padding: '10px 14px', color: '#fff', fontSize: '0.65rem', fontFamily: "'Monda',sans-serif", outline: 'none', width: '100%', colorScheme: 'dark', appearance: 'auto' },
  label: { fontFamily: "'Monda', sans-serif", fontSize: '0.6rem', letterSpacing: '1.5px', color: 'rgba(255,255,255,0.35)', marginBottom: '6px', display: 'block' },
};

// Team structure: how participants are grouped per rule
// Each array = team sizes. e.g. [2,2] = 2 teams of 2, [1,2] = solo vs team of 2
const RULE_TEAMS = {
  '1v1':              [1, 1],
  'tag':              [2, 2],
  'triple-threat':    [1, 1, 1],
  'fatal-4-way':      [1, 1, 1, 1],
  'five-way':         [1, 1, 1, 1, 1],
  'six-way':          [1, 1, 1, 1, 1, 1],
  '3v3':              [3, 3],
  'tag-triple-threat':[2, 2, 2],
  'eight-way':        [1, 1, 1, 1, 1, 1, 1, 1],
  '4v4':              [4, 4],
  'tag-fatal-4-way':  [2, 2, 2, 2],
  '1v2':              [1, 2],
  '1v3':              [1, 3],
  '2v3':              [2, 3],
};

// Group flat participants array into teams based on rule
const groupIntoTeams = (participants, ruleId) => {
  const teamSizes = RULE_TEAMS[ruleId] || [1, 1];
  const teams = [];
  let idx = 0;
  for (const size of teamSizes) {
    teams.push(participants.slice(idx, idx + size));
    idx += size;
  }
  return teams;
};

// How many participants per match rule
const getRuleParticipants = (ruleId) => {
  const map = {
    '1v1': 2, 'tag': 4, 'triple-threat': 3, 'fatal-4-way': 4,
    'five-way': 5, 'six-way': 6, '3v3': 6, 'tag-triple-threat': 6,
    'eight-way': 8, '4v4': 8, 'tag-fatal-4-way': 8,
    '1v2': 3, '1v3': 4, '2v3': 5,
  };
  return map[ruleId] || 2;
};


// ── Logistics unlock map ─────────────────────────────────────────────
const LOGISTICS_UNLOCK_MAP = {
  // crew rank 2
  'backstage-brawl':       { source: 'crew', rank: 2 },
  'last-man-standing':     { source: 'crew', rank: 2 },
  // crew rank 3
  'ambulance':             { source: 'crew', rank: 3 },
  'no-holds-barred':       { source: 'crew', rank: 3 },
  // crew rank 4
  'battle-royal':          { source: 'crew', rank: 4 },
  'dumpster':              { source: 'crew', rank: 4 },
  // sfx rank 2
  'steel-cage':            { source: 'sfx', rank: 2 },
  'gauntlet':              { source: 'sfx', rank: 2 },
  // sfx rank 3
  'gauntlet-eliminator':   { source: 'sfx', rank: 3 },
  'inferno':               { source: 'sfx', rank: 3 },
  // sfx rank 4
  'casket':                { source: 'sfx', rank: 4 },
  'i-quit':                { source: 'sfx', rank: 4 },
  // advertising rank 2
  'submission':            { source: 'advertising', rank: 2 },
  'tornado-tag':           { source: 'advertising', rank: 2 },
  // advertising rank 3
  'iron-man':              { source: 'advertising', rank: 3 },
  'underground':           { source: 'advertising', rank: 3 },
  // advertising rank 4
  'special-guest-referee': { source: 'advertising', rank: 4 },
  'bloodline-rules':       { source: 'advertising', rank: 4 },
};


// Match specialist icon helper
const getMatchSpecialistIcon = () => process.env.PUBLIC_URL + '/icons/match_specialist.png';

// Check if wrestler is specialist for current match type
export const isMatchSpecialist = (wrestler, matchTypeId) => {
  if (!wrestler || !matchTypeId || matchTypeId === 'normal') return false;
  const types = wrestler.match_types || [];
  return types.includes(matchTypeId);
};

// ── Class Synergy System ─────────────────────────────────────────────
// Positive synergy pairs (bidirectional)
const SYNERGY_PAIRS = [
  ['Giant', 'Cruiser'],
  ['Bruiser', 'Fighter'],
];

// Check if two wrestlers have direct class synergy (1v1 case)
const hasDirectSynergy = (class1, class2) => {
  if (!class1 || !class2) return false;
  if (class1 === 'Specialist' || class2 === 'Specialist') return false;
  return SYNERGY_PAIRS.some(([a, b]) => 
    (class1 === a && class2 === b) || (class1 === b && class2 === a)
  );
};

// Check if a wrestler has synergy with the current group (for visual glow)
// Rules:
//   - Specialist class is NEUTRAL: never glows, never gives synergy to others
//   - 1v1 / 1v1 mode (1 other participant): glow if direct pair (Giant<->Cruiser, Bruiser<->Fighter, Fighter<->Cruiser)
//   - 3+ participants (multi-person): glow only on wrestlers whose class is NOT already represented by another wrestler in the group
//     (i.e. they bring diversity that the group is currently missing).
export const hasSynergyWithGroup = (wrestler, allParticipants) => {
  if (!wrestler || !wrestler.fight_class) return false;
  if (wrestler.fight_class === 'Specialist') return false;
  
  const others = (allParticipants || []).filter(p => p && p.wrestler_id !== wrestler.wrestler_id);
  if (others.length === 0) return false;
  
  // Multi-person mode (3+ wrestlers total): show glow on classes that are NOT already represented
  if (others.length >= 2) {
    // Collect classes already in the group from others (excluding self), ignoring Specialist
    const otherClasses = others.map(p => p.fight_class).filter(c => c && c !== 'Specialist');
    // The wrestler glows only if its class is NOT already among the others' classes
    return !otherClasses.includes(wrestler.fight_class);
  }
  
  // 1v1 / direct check (exactly 1 other wrestler): glow if direct pair
  for (const other of others) {
    if (hasDirectSynergy(wrestler.fight_class, other.fight_class)) {
      return true;
    }
  }
  
  return false;
};

// Glow style for synergy (blue glow)
const SYNERGY_GLOW = '0 0 14px 2px rgba(52, 152, 219, 0.55), 0 0 28px rgba(52, 152, 219, 0.25)';



const getLockedReason = (matchTypeId, logistics, matchType) => {
  if (matchType !== 'unlock') return null; // classic mode = all unlocked
  var req = LOGISTICS_UNLOCK_MAP[matchTypeId];
  if (!req) return null;
  var currentRank = (logistics && logistics[req.source]) || 1;
  if (currentRank >= req.rank) return null;
  var sourceLabel = req.source === 'sfx' ? 'Special Effects' : req.source.charAt(0).toUpperCase() + req.source.slice(1);
  return sourceLabel + ' Rank ' + req.rank;
};


// ── Detect rivalries between participants ─────────────────────────────
const RIVALRY_LEVEL_COLORS = { 1: '#3498db', 2: '#e67e22', 3: '#e74c3c', 4: '#d4af37' };
const RIVALRY_LEVEL_LABELS = { 1: 'Niv.1 - Début', 2: 'Niv.2 - Intense', 3: 'Niv.3 - Chauffé', 4: 'Niv.4 - Blood Feud' };

// Returns first rivalry where at least 1 from each side is present (kept for backward compat)
const detectRivalry = (participants, rivalries) => {
  var result = detectAllRivalries(participants, rivalries);
  return result.length > 0 ? result[0] : null;
};

// Returns ALL rivalries where EVERY member of BOTH sides is present in the match
const detectAllRivalries = (participants, rivalries) => {
  if (!rivalries || rivalries.length === 0 || !participants || participants.length === 0) return [];
  var pIds = participants.filter(Boolean).map(function(p) { return String(p.wrestler_id); });
  return rivalries.filter(function(rv) {
    if (rv.ended) return false;
    var side1 = (rv.side1 || []).map(String);
    var side2 = (rv.side2 || []).map(String);
    if (side1.length === 0 || side2.length === 0) return false;
    // ALL members of both sides must be in the match
    return side1.every(function(id) { return pIds.includes(id); }) &&
           side2.every(function(id) { return pIds.includes(id); });
  });
};

// ── Superstar Picker Popup ──────────────────────────────────────────
const RIVALRY_LVL_COLORS_PKR = { 1: '#3498db', 2: '#e67e22', 3: '#e74c3c', 4: '#9b59b6' };

// ── Match Maker Popup ───────────────────────────────────────────────
const GM_RENDERS_MAP = {
  'Adam Pearce': require('../assets/gm/94400_ADAM_PEARCE.png'),
  'Nick Aldis': require('../assets/gm/121300_NICK_ALDIS.png'),
  'Shawn Michaels': require('../assets/gm/45750_SHAWN_MICHAELS.png'),
  'Ava': require('../assets/gm/121400_AVA.png'),
  'Stephanie McMahon': require('../assets/gm/14700_STEPHANIE_MCMAHON.png'),
  'Paul Heyman': require('../assets/gm/37410_PAUL_HEYMAN_14.png'),
  'William Regal': require('../assets/gm/94010_WILLIAM_REGAL.png'),
  'Mick Foley': require('../assets/gm/14400_MICK_FOLEY.png'),
  'Teddy Long': require('../assets/gm/28600_TEDDY_LONG.png'),
  'Eric Bischoff': require('../assets/gm/93900_ERIC_BISCHOFF.png'),
  'Sensational Sherri': require('../assets/gm/42850_SENSATIONAL_SHERRI.png'),
  'Miss Elizabeth': require('../assets/gm/23450_MISS_ELIZABETH.png'),
  'Mr Fuji': require('../assets/gm/130250_MR_FUJI.png'),
  'Bobby Heenan': require('../assets/gm/24900_BOBBY_HENNAN.png'),
  'CM Punk': require('../assets/gm/31250_CM_PUNK.png'),
  'Xavier Woods': require('../assets/gm/42030_XAVIER_WOODS.png'),
  'Tyler Breeze': require('../assets/gm/58110_TYLER_BREEZE.png'),
  'Stacy Keibler': require('../assets/gm/148600_STACY_KEIBLER_GM.png'),
  'Anonymous GM': require('../assets/gm/149100_ANONYMOUS_GM.png'),
};

export const MatchMaker = ({ slot, roster, champions, difficulty, onClose, onSave, gmName, rivals, matchBookedIds, logistics, matchTypeSetting, rivalries, tagTeams, brandBg, brandColor: brandColorProp, rivalBrands, disableTitleMatch, currentWeek }) => {
  const brandColor = brandColorProp || '#d4af37';
  const [matchRule, setMatchRule] = useState(slot?.booking?.matchRule || '1v1');
  const [matchType, setMatchType] = useState(slot?.booking?.matchType || 'normal');
  const [participants, setParticipants] = useState(slot?.booking?.participants || []);
  const [titleMatch, setTitleMatch] = useState(slot?.booking?.titleMatch || null);
  const [interference, setInterference] = useState(slot?.booking?.interference || 'none');
  const [guestReferee, setGuestReferee] = useState(slot?.booking?.guestReferee || null);
  const [promoAction, setPromoAction] = useState(slot?.booking?.promoAction || null);
  const [promoTargets, setPromoTargets] = useState(slot?.booking?.promoTargets || []);
  const [promoRivalTarget, setPromoRivalTarget] = useState(slot?.booking?.promoRivalTarget || null);
  const [interferenceA, setInterferenceA] = useState(slot?.booking?.interferenceA || null);
  const [interferenceB, setInterferenceB] = useState(slot?.booking?.interferenceB || null);
  const [pickerIdx, setPickerIdx] = useState(null); // which participant slot is being picked
  const [pickerType, setPickerType] = useState(null); // 'participant' | 'intA' | 'intB'
  const [costOverride, setCostOverride] = useState(slot?.booking?.costOverride ?? null);
  const [editingCost, setEditingCost] = useState(false);
  const [costInput, setCostInput] = useState('');

  const isPromo = slot?.type === 'promo';
  const isSpecialGuestRef = !isPromo && matchType === 'special-guest-referee';
  const numParticipants = getRuleParticipants(matchRule);
  const interferenceCost = (interference && interference !== 'none') ? (INTERFERENCE_COST[interference] || 0) : 0;
  const hasMale = participants.some(function(p) { return p && p.gender === 'M'; });
  const hasFemale = participants.some(function(p) { return p && p.gender === 'F'; });
  const mixedGenderCost = (!isPromo && hasMale && hasFemale) ? 5000 : 0;
  const matchPrice = getMatchPrice(matchType, difficulty) + interferenceCost + mixedGenderCost;
  const promoPrice = isPromo ? (PROMO_ACTIONS.find(function(a) { return a.id === promoAction; })?.cost || 0) : 0;
  const baseDisplayCost = isPromo ? promoPrice : matchPrice;
  const rule = MATCH_RULES.find(r => r.id === matchRule);

  const champSlots = champions?.slots || [];
  // champion slots used for title match selection

  // ── Champion helper ────────────────────────────────────────────────
  var champMap2 = (champions && champions.champions) || {};
  var champSlots2 = (champions && champions.slots) || [];
  var getChampSlot = function(w) {
    if (!w) return null;
    var found = null;
    Object.keys(champMap2).forEach(function(slotKey) {
      var val = champMap2[slotKey];
      var wrestlers = Array.isArray(val) ? val : (val ? [val] : []);
      var isChamp = wrestlers.some(function(cw) {
        return cw && String(cw.wrestler_id) === String(w.wrestler_id);
      });
      if (isChamp) found = champSlots2.find(function(s) { return s.key === slotKey; }) || { key: slotKey };
    });
    return found;
  };

  // ── Teams grouping ───────────────────────────────────────────────────
  var teamSizes2 = RULE_TEAMS[matchRule] || [1, 1];
  var teams2 = [];
  var idx2 = 0;
  teamSizes2.forEach(function(size) {
    teams2.push(Array.from({ length: size }).map(function(_, i) { return participants[idx2 + i] || null; }));
    idx2 += size;
  });

  // ── Check champions in match (filtered by match type) ──────────────
  var isTagRule = matchRule === 'tag' || matchRule === 'tag-triple-threat' || matchRule === 'tag-fatal-4-way' || matchRule === '3v3' || matchRule === '4v4';

  // ── Warning: rivals dans la même équipe ──────────────────────────────
  var rivalsOnSameTeam = false;
  if (isTagRule && rivalries && rivalries.length > 0) {
    teams2.forEach(function(team) {
      var teamIds = team.filter(Boolean).map(function(w) { return String(w.wrestler_id); });
      if (teamIds.length < 2) return;
      rivalries.forEach(function(r) {
        var s1 = (r.side1 || []).map(String);
        var s2 = (r.side2 || []).map(String);
        // Rival pair = one id in s1, other id in s2, both in same team
        var s1InTeam = teamIds.filter(function(id) { return s1.includes(id); });
        var s2InTeam = teamIds.filter(function(id) { return s2.includes(id); });
        if (s1InTeam.length > 0 && s2InTeam.length > 0) rivalsOnSameTeam = true;
      });
    });
  }
  var champsInMatch = participants.filter(Boolean).filter(function(p) {
    var cs = getChampSlot(p);
    if (!cs) return false;
    return isTagRule ? !!cs.isTagTeam : !cs.isTagTeam;
  });
  var champSlotsInMatch = champsInMatch.map(function(p) { return getChampSlot(p); }).filter(Boolean);
  // Deduplicate by slot key
  var seenKeys = {};
  champSlotsInMatch = champSlotsInMatch.filter(function(s) {
    if (seenKeys[s.key]) return false;
    seenKeys[s.key] = true;
    return true;
  });
  var champInMatch = champsInMatch.length > 0 ? champsInMatch[0] : null;
  var champMatchSlot = champSlotsInMatch.length === 1 ? champSlotsInMatch[0] : null;
  var multipleChampSlots = champSlotsInMatch.length > 1;

  // ── Interference state ───────────────────────────────────────────────
  var showInterference = interference !== 'none';

  return (
    <div style={{ position: 'fixed', inset: 0, zIndex: 400, display: 'flex', alignItems: 'center', justifyContent: 'center', background: 'rgba(0,0,0,0.88)' }}>
      {(() => {
        // Dynamic width based on number of participants
        var totalP = numParticipants;
        var baseCardW = 140; // card width
        var vsW = 80; // VS block width per team separator
        var numTeams = teamSizes2.length;
        var padding = 48 + 32; // side padding
        var calcW = totalP * baseCardW + totalP * 1 + (numTeams - 1) * vsW + padding;
        var dynW = Math.min(calcW, window.innerWidth * 0.95);
        dynW = Math.max(dynW, 580); // minimum width
        return null;
      })()}
      <div style={{ width: (function() {
        if (isPromo) {
          // Promos: always 4 card slots (2 callers + arrow + 2 targets) max
          return 'min(820px, 95vw)';
        }
        var totalP = numParticipants;
        var baseCardW = 140;
        var vsW = 80;
        var numTeams = teamSizes2.length;
        var padding = 80;
        var calcW = totalP * baseCardW + (numTeams - 1) * vsW + padding;
        return 'min(' + Math.max(calcW, 580) + 'px, 95vw)';
      })(), maxHeight: '92vh', background: 'rgba(8,8,8,0.97)', border: '1px solid rgba(255,255,255,0.1)', borderRadius: '12px', display: 'flex', flexDirection: 'column', overflow: 'hidden' }}>

        {/* SuperstarPicker overlay */}
        {pickerIdx !== null && (
          <SuperstarPicker
            champions={champions}
            roster={roster}
            alreadyPicked={participants.concat(guestReferee ? [guestReferee] : [])}
            currentSlotType={slot && slot.type}
            isTarget={pickerType === 'promoTarget'}
            promoAction={isPromo ? promoAction : null}
            rivalries={rivalries}
            matchBookedIds={matchBookedIds || []}
            matchType={matchType}
            rivalBrands={pickerType === 'participant' ? (rivalBrands || null) : null}
            currentWeek={currentWeek}
            onSelect={(w) => {
              if (pickerType === 'participant') {
                var p = Array.from({ length: numParticipants }).map(function(_, i) { return participants[i] || null; });
                p[pickerIdx] = w;
                var bookedIds = matchBookedIds || [];
                var findW = function(id) { return roster.find(function(rw) { return String(rw.wrestler_id) === String(id); }); };
                var isFree = function(id) { return !bookedIds.includes(id) && !p.some(function(x) { return x && String(x.wrestler_id) === String(id); }); };

                // ── Brand participant: just place it, skip all rivalry/team auto-fill ──
                if (w && w.isBrand) {
                  setParticipants(p);
                  return;
                }

                // ── Team sizes for current rule ──
                var teamSizesAF = RULE_TEAMS[matchRule] || [1, 1];
                var isTeamMatch = teamSizesAF.some(function(s) { return s > 1; });

                // ── Find rivalry for the picked wrestler ──
                var myRivalry = (rivalries || []).find(function(r) {
                  return (r.side1 || []).some(function(id) { return String(id) === String(w.wrestler_id); }) ||
                         (r.side2 || []).some(function(id) { return String(id) === String(w.wrestler_id); });
                });

                // ── Helper: find which team slot the pickerIdx belongs to ──
                var getTeamInfo = function(idx, sizes) {
                  var count = 0;
                  for (var ti = 0; ti < sizes.length; ti++) {
                    var nextCount = count + sizes[ti];
                    if (idx < nextCount) {
                      return { teamIdx: ti, teamStart: count, teamSize: sizes[ti], slotInTeam: idx - count };
                    }
                    count = nextCount;
                  }
                  return { teamIdx: 0, teamStart: 0, teamSize: sizes[0], slotInTeam: 0 };
                };

                if (isTeamMatch && !isPromo) {
                  var teamInfo = getTeamInfo(pickerIdx, teamSizesAF);
                  var myTeamSize = teamInfo.teamSize;
                  var myTeamStart = teamInfo.teamStart;

                  // Find my rivalry side
                  var inS1team = myRivalry && (myRivalry.side1 || []).some(function(id) { return String(id) === String(w.wrestler_id); });
                  var mySideIds = myRivalry ? (inS1team ? (myRivalry.side1 || []) : (myRivalry.side2 || [])) : [];
                  var rivalSideIds = myRivalry ? (inS1team ? (myRivalry.side2 || []) : (myRivalry.side1 || [])) : [];

                  // Step 1: Fill my team slots with my rivalry teammates
                  if (mySideIds.length > 1) {
                    var myPartnerIds = mySideIds.filter(function(id) { return String(id) !== String(w.wrestler_id); });
                    var emptyTeamSlots = [];
                    for (var si = 0; si < myTeamSize; si++) {
                      var slotGlobal = myTeamStart + si;
                      if (p[slotGlobal] == null && slotGlobal !== pickerIdx) emptyTeamSlots.push(slotGlobal);
                    }
                    myPartnerIds.forEach(function(pid, pi) {
                      var pw = findW(pid);
                      if (pw && isFree(pw.wrestler_id) && pi < emptyTeamSlots.length) {
                        p[emptyTeamSlots[pi]] = pw;
                      }
                    });
                  } else {
                    // No rivalry team partner — try:
                    // 1. Tag team champions (champions.champions for tag slots)
                    // 2. Registered tagTeams
                    var regPartnerFound = null;

                    // Check tag champions first
                    if (!regPartnerFound && champions && champions.champions && champions.slots) {
                      var tagSlots = (champions.slots || []).filter(function(s) { return s.isTagTeam; });
                      tagSlots.forEach(function(ts) {
                        if (regPartnerFound) return;
                        var holders = (champions.champions[ts.key] || []).filter(Boolean);
                        var isChampHere = holders.some(function(h) { return String(h.wrestler_id) === String(w.wrestler_id); });
                        if (isChampHere && holders.length > 1) {
                          var partnerChamp = holders.find(function(h) { return String(h.wrestler_id) !== String(w.wrestler_id); });
                          if (partnerChamp) {
                            var fullPartner = findW(partnerChamp.wrestler_id) || partnerChamp;
                            if (isFree(fullPartner.wrestler_id)) regPartnerFound = fullPartner;
                          }
                        }
                      });
                    }

                    // Then registered tagTeams
                    if (!regPartnerFound) {
                      var myRegisteredTeam = (tagTeams || []).find(function(t) {
                        return (t.partner1 && String(t.partner1.wrestler_id) === String(w.wrestler_id)) ||
                               (t.partner2 && String(t.partner2.wrestler_id) === String(w.wrestler_id));
                      });
                      if (myRegisteredTeam) {
                        var rp = String(myRegisteredTeam.partner1.wrestler_id) === String(w.wrestler_id) ? myRegisteredTeam.partner2 : myRegisteredTeam.partner1;
                        var fullRp = findW(rp.wrestler_id) || rp;
                        if (isFree(fullRp.wrestler_id)) regPartnerFound = fullRp;
                      }
                    }

                    // Place the partner and then fill rivals
                    if (regPartnerFound && myTeamSize > 1) {
                      var partnerEmptySlot = -1;
                      for (var si2 = 0; si2 < myTeamSize; si2++) {
                        var sg2 = myTeamStart + si2;
                        if (p[sg2] == null && sg2 !== pickerIdx) { partnerEmptySlot = sg2; break; }
                      }
                      if (partnerEmptySlot !== -1) {
                        p[partnerEmptySlot] = regPartnerFound;
                        // Update for rival detection
                        mySideIds = [w.wrestler_id, regPartnerFound.wrestler_id];
                        if (!myRivalry) {
                          myRivalry = (rivalries || []).find(function(r) {
                            return mySideIds.some(function(id) {
                              return (r.side1 || []).some(function(x) { return String(x) === String(id); }) ||
                                     (r.side2 || []).some(function(x) { return String(x) === String(id); });
                            });
                          });
                          if (myRivalry) {
                            var inS1reg = mySideIds.some(function(id) { return (myRivalry.side1 || []).some(function(x) { return String(x) === String(id); }); });
                            rivalSideIds = inS1reg ? (myRivalry.side2 || []) : (myRivalry.side1 || []);
                          }
                        }
                      }
                    }
                  }

                  // Step 2: Fill the FIRST available opposite team with rivalry opponents
                  if (rivalSideIds.length > 0) {
                    // Find the first team that isn't mine and has empty slots
                    var filled = false;
                    var slotOffset = 0;
                    for (var ti2 = 0; ti2 < teamSizesAF.length && !filled; ti2++) {
                      if (ti2 === teamInfo.teamIdx) { slotOffset += teamSizesAF[ti2]; continue; }
                      var thisTeamStart = slotOffset;
                      var thisTeamSize = teamSizesAF[ti2];
                      var hasEmpty = false;
                      for (var si3 = 0; si3 < thisTeamSize; si3++) {
                        if (p[thisTeamStart + si3] == null) { hasEmpty = true; break; }
                      }
                      if (hasEmpty) {
                        rivalSideIds.forEach(function(rid, ri) {
                          var rw = findW(rid);
                          var rslot = thisTeamStart + ri;
                          if (rw && rslot < thisTeamStart + thisTeamSize && rslot < numParticipants && p[rslot] == null && isFree(rid)) {
                            p[rslot] = rw;
                          }
                        });
                        filled = true;
                      }
                      slotOffset += thisTeamSize;
                    }
                  }

                } else if (isPromo && promoAction === 'tag-team-call-out') {
                  // ── Tag Call-Out promo ──
                  if (pickerType === 'participant' && myRivalry) {
                    var inS1co = (myRivalry.side1 || []).some(function(id) { return String(id) === String(w.wrestler_id); });
                    var mySideCO = inS1co ? (myRivalry.side1 || []) : (myRivalry.side2 || []);
                    var rivalSideCO = inS1co ? (myRivalry.side2 || []) : (myRivalry.side1 || []);
                    // Auto-fill partner caller
                    var coPartnerId = mySideCO.find(function(id) { return String(id) !== String(w.wrestler_id); });
                    var coPartner = coPartnerId ? findW(coPartnerId) : null;
                    if (coPartner && isFree(coPartner.wrestler_id)) {
                      var callerSlot2 = pickerIdx === 0 ? 1 : 0;
                      if (p[callerSlot2] == null) p[callerSlot2] = coPartner;
                    }
                    // Auto-fill targets from rival side
                    var newTargets = [...promoTargets];
                    rivalSideCO.forEach(function(rid, ri) {
                      var rw = findW(rid);
                      if (rw && ri < 2 && newTargets[ri] == null) newTargets[ri] = rw;
                    });
                    setPromoTargets(newTargets);
                  }
                } else if (isPromo && promoAction === 'call-out' && pickerType === 'participant' && myRivalry) {
                  // ── Solo Call-Out: auto-fill target from rivalry ──
                  var inS1callout = (myRivalry.side1 || []).some(function(id) { return String(id) === String(w.wrestler_id); });
                  var rivalCalloutIds = inS1callout ? (myRivalry.side2 || []) : (myRivalry.side1 || []);
                  var newTargetsSolo = [...promoTargets];
                  rivalCalloutIds.forEach(function(rid, ri) {
                    var rw = findW(rid);
                    if (rw && ri < 1 && newTargetsSolo[0] == null) newTargetsSolo[0] = rw;
                  });
                  setPromoTargets(newTargetsSolo);
                } else if (!isPromo && myRivalry) {
                  // ── Solo / multi-man match (1v1, triple threat, fatal 4-way...) ──
                  var inS1solo = (myRivalry.side1 || []).some(function(id) { return String(id) === String(w.wrestler_id); });
                  var rivalIdsSolo = inS1solo ? (myRivalry.side2 || []) : (myRivalry.side1 || []);
                  rivalIdsSolo.forEach(function(rid) {
                    var rw = findW(rid);
                    var emptyIdx = p.findIndex(function(x, xi) { return xi !== pickerIdx && x == null; });
                    if (rw && emptyIdx !== -1 && isFree(rid)) { p[emptyIdx] = rw; }
                  });
                }
                setParticipants(p);
              } else if (pickerType === 'promoTarget') { const t = [...promoTargets]; t[pickerIdx - 100] = w; setPromoTargets(t); }
              else if (pickerType === 'intA') setInterferenceA(w);
              else if (pickerType === 'intB') setInterferenceB(w);
              else if (pickerType === 'guestReferee') setGuestReferee(w);
            }}
            onClose={() => { setPickerIdx(null); setPickerType(null); }}
          />
        )}

        {/* ── HEADER ── */}
        <div style={{ padding: '16px 24px', borderBottom: '1px solid rgba(255,255,255,0.08)', display: 'flex', alignItems: 'center', justifyContent: 'space-between', flexShrink: 0 }}>
          <div style={{ display: 'flex', alignItems: 'baseline', gap: '12px' }}>
            <div style={{ fontFamily: "'Anton',sans-serif", fontSize: '1.6rem', letterSpacing: '3px', color: SLOT_COLORS[slot && slot.type] || '#fff' }}>{SLOT_LABELS[slot && slot.type] || 'MATCH'}</div>
            <div style={{ fontFamily: "'Monda',sans-serif", fontSize: '0.5rem', color: 'rgba(255,255,255,0.3)', letterSpacing: '1.5px' }}>{isPromo ? 'PROMO MAKER' : 'MATCH MAKER'}</div>
          </div>
          <div style={{ display: 'flex', alignItems: 'baseline', gap: '8px' }}>
            <div style={{ fontFamily: "'Monda',sans-serif", fontSize: '0.52rem', color: 'rgba(255,255,255,0.4)', letterSpacing: '1px' }}>{isPromo ? 'PROMO COST :' : 'MATCH COST :'}</div>
            <div style={{ fontFamily: "'Anton',sans-serif", fontSize: '1.6rem', color: '#d4af37', letterSpacing: '1px' }}>${(isPromo ? (PROMO_ACTIONS.find(function(a) { return a.id === promoAction; }) ? (PROMO_ACTIONS.find(function(a) { return a.id === promoAction; }).cost || 0) : 0) : matchPrice).toLocaleString('fr-FR')}</div>
          </div>
        </div>
        {/* ── Rival same team warning ── */}
        {rivalsOnSameTeam && (
          <div style={{ fontFamily: "'Monda',sans-serif", fontSize: '0.45rem', letterSpacing: '1px', color: '#f39c12', background: 'rgba(243,156,18,0.07)', borderBottom: '1px solid rgba(243,156,18,0.2)', padding: '7px 24px', display: 'flex', alignItems: 'center', gap: '8px' }}>
            <span>⚠</span> Rivals are on the same team — you can keep this booking if intended.
          </div>
        )}

        {/* ── CONTROLS ROW — match only ── */}
        {!isPromo && (
        <div style={{ padding: '12px 24px', borderBottom: '1px solid rgba(255,255,255,0.06)', display: 'flex', gap: '24px', alignItems: 'center', flexShrink: 0, background: 'rgba(0,0,0,0.3)' }}>
          <div style={{ display: 'flex', alignItems: 'center', gap: '10px', flex: 1 }}>
            <div style={{ fontFamily: "'Monda',sans-serif", fontSize: '0.44rem', color: 'rgba(255,255,255,0.4)', letterSpacing: '1.5px', flexShrink: 0 }}>MATCH RULES</div>
            <select style={{ ...S.input, flex: 1, colorScheme: 'dark' }} value={matchRule} onChange={e => {
              const newRule = e.target.value;
              const newSize = getRuleParticipants(newRule);
              setMatchRule(newRule);
              // Preserve already-picked wrestlers when changing rule:
              //  - if new rule has more slots, pad with null
              //  - if new rule has fewer slots, truncate (keep first N)
              setParticipants(prev => {
                const kept = (prev || []).slice(0, newSize);
                while (kept.length < newSize) kept.push(null);
                return kept;
              });
              setTitleMatch(null);
              const available = getMatchTypesForRule(newRule);
              if (!available.find(m => m.id === matchType)) setMatchType(available[0] ? available[0].id : 'normal');
            }}>
              {MATCH_RULES.map(r => <option key={r.id} value={r.id}>{r.name}</option>)}
            </select>
          </div>
          <div style={{ display: 'flex', alignItems: 'center', gap: '10px', flex: 1 }}>
            <div style={{ fontFamily: "'Monda',sans-serif", fontSize: '0.44rem', color: 'rgba(255,255,255,0.4)', letterSpacing: '1.5px', flexShrink: 0 }}>MATCH TYPE</div>
            <select style={{ ...S.input, flex: 1, colorScheme: 'dark' }} value={matchType} onChange={e => {
              var locked = getLockedReason(e.target.value, logistics, matchTypeSetting);
              if (!locked) { setMatchType(e.target.value); setCostOverride(null); setEditingCost(false); }
            }}>
              {getMatchTypesForRule(matchRule).map(m => {
                var locked = getLockedReason(m.id, logistics, matchTypeSetting);
                return <option key={m.id} value={m.id} disabled={!!locked}>{locked ? '🔒 ' : ''}{m.name}</option>;
              })}
            </select>
          </div>
        </div>
        )}

        {/* ── PROMO ACTION SELECTOR ── */}
        {isPromo && (
          <div style={{ padding: '12px 24px', borderBottom: '1px solid rgba(255,255,255,0.06)', display: 'flex', gap: '10px', flexWrap: 'wrap', flexShrink: 0, background: 'rgba(0,0,0,0.3)', overflowY: 'auto', maxHeight: '200px' }}>
            {PROMO_ACTIONS.filter(a => !a.comingSoon).map(function(action) { return (
              <div key={action.id} onClick={() => { setPromoAction(action.id); setPromoTargets([]); setPromoRivalTarget(null); setCostOverride(null); setEditingCost(false); }}
                style={{ borderRadius: '6px', padding: '8px 14px', border: '1px solid ' + (promoAction === action.id ? '#d4af37' : 'rgba(255,255,255,0.1)'), background: promoAction === action.id ? 'rgba(212,175,55,0.1)' : 'rgba(255,255,255,0.02)', cursor: 'pointer', transition: 'background 0.15s, border-color 0.15s', minWidth: '160px', flex: 1 }}>
                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '3px' }}>
                  <div style={{ fontFamily: "'Monda',sans-serif", fontSize: '0.52rem', color: promoAction === action.id ? '#d4af37' : '#fff', letterSpacing: '0.5px' }}>{action.name}</div>
                  <div style={{ fontFamily: "'Monda',sans-serif", fontSize: '0.44rem', color: action.cost === 0 ? '#2ecc71' : '#d4af37' }}>{action.cost === 0 ? 'FREE' : '$' + action.cost.toLocaleString('fr-FR')}</div>
                </div>
                <div style={{ fontFamily: "'Monda',sans-serif", fontSize: '0.4rem', color: 'rgba(255,255,255,0.35)', lineHeight: '1.4' }}>{action.description}</div>
              </div>
            ); })}
          </div>
        )}

        {/* ── SPECIAL GUEST REFEREE ENCART ── */}
        {isSpecialGuestRef && (
          <div style={{ flexShrink: 0, padding: '8px 24px', borderBottom: '1px solid rgba(255,255,255,0.06)', background: 'rgba(212,175,55,0.04)', display: 'flex', alignItems: 'center', gap: '14px' }}>
            <div style={{ fontFamily: "'Monda',sans-serif", fontSize: '0.44rem', color: '#d4af37', letterSpacing: '1.5px', flexShrink: 0 }}>⚖ SPECIAL GUEST REFEREE</div>
            {guestReferee ? (
              <div style={{ display: 'flex', alignItems: 'center', gap: '10px', padding: '5px 12px', background: 'rgba(212,175,55,0.08)', border: '1px solid rgba(212,175,55,0.35)', borderRadius: '6px', cursor: 'pointer' }}
                onClick={() => { setPickerIdx(300); setPickerType('guestReferee'); }}>
                <img loading="lazy" src={getWrestlerRender(guestReferee) || placeholder} alt="" style={{ width: '28px', height: '36px', objectFit: 'contain', objectPosition: 'top' }} />
                <div style={{ fontFamily: "'Anton',sans-serif", fontSize: '0.55rem', color: '#d4af37' }}>{getWrestlerNameUpper(guestReferee, 'display')}</div>
                <button onClick={function(e) { e.stopPropagation(); setGuestReferee(null); }}
                  style={{ background: 'rgba(231,76,60,0.15)', border: '1px solid rgba(231,76,60,0.4)', color: '#e74c3c', borderRadius: '3px', padding: '1px 6px', cursor: 'pointer', fontFamily: "'Monda',sans-serif", fontSize: '0.38rem', marginLeft: '4px' }}>✕</button>
              </div>
            ) : (
              <div onClick={() => { setPickerIdx(300); setPickerType('guestReferee'); }}
                style={{ display: 'flex', alignItems: 'center', gap: '8px', padding: '6px 14px', background: 'rgba(212,175,55,0.05)', border: '1px dashed rgba(212,175,55,0.3)', borderRadius: '6px', cursor: 'pointer' }}>
                <div style={{ fontFamily: "'Monda',sans-serif", fontSize: '0.42rem', color: 'rgba(212,175,55,0.5)' }}>+ SELECT REFEREE</div>
              </div>
            )}
          </div>
        )}

        {/* ── PARTICIPANTS ZONE ── */}
        <div style={{ flex: 1, position: 'relative', overflow: 'hidden', minHeight: '300px' }}>
          {/* Brand/PLE background */}
          {brandBg && <img loading="lazy" src={brandBg} alt="" style={{ position: 'absolute', inset: 0, width: '100%', height: '100%', objectFit: 'cover', filter: 'blur(8px) brightness(0.25)', zIndex: 0 }} />}
          <div style={{ position: 'absolute', inset: 0, background: 'radial-gradient(ellipse at center, ' + brandColor + '12 0%, rgba(0,0,0,0.5) 100%)', zIndex: 1 }} />

          {/* Participants label */}
          <div style={{ position: 'absolute', top: '10px', left: '16px', zIndex: 3, fontFamily: "'Monda',sans-serif", fontSize: '0.44rem', color: 'rgba(255,255,255,0.35)', letterSpacing: '2px' }}>{isPromo ? (promoAction ? (PROMO_CONFIG[promoAction] && PROMO_CONFIG[promoAction].label || 'PARTICIPANT') : 'SELECT AN ACTION FIRST') : 'PARTICIPANTS'}</div>

          {/* Wrestler cards */}
          <div style={{ position: 'relative', zIndex: 2, height: '100%', display: 'flex', alignItems: 'center', justifyContent: 'center', padding: '32px 24px 16px', gap: 0 }}>
            {isPromo ? (function() {
              if (!promoAction) {
                // No action selected — show one empty slot
                return (
                  <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', height: '100%' }}>
                    <div style={{ fontFamily: "'Monda',sans-serif", fontSize: '0.52rem', color: 'rgba(255,255,255,0.25)', letterSpacing: '1px' }}>SELECT AN ACTION FIRST</div>
                  </div>
                );
              }
              var cfg = PROMO_CONFIG[promoAction];
              var callerCount = cfg ? (cfg.participants || 1) : 1;
              var hasTarget = cfg && cfg.hasTarget;
              var targetCount = cfg ? (cfg.targetCount || 0) : 0;
              var callerSlots = Array.from({ length: callerCount }).map(function(_, i) { return participants[i] || null; });
              var targetSlots = hasTarget ? Array.from({ length: targetCount }).map(function(_, i) { return promoTargets[i] || null; }) : [];

              var renderSlot = function(w, idx, type) {
                var isTarget = type === 'target';
                var borderCol = isTarget ? 'rgba(231,76,60,0.5)' : brandColor + '55';
                return (
                  <div key={type + idx} onClick={function() {
                    if (isTarget) { setPickerIdx(100 + idx); setPickerType('promoTarget'); }
                    else { setPickerIdx(idx); setPickerType('participant'); }
                  }}
                  style={{ width: '140px', height: '240px', position: 'relative', cursor: 'pointer', borderRadius: '8px', overflow: 'hidden', border: '1px solid ' + (w ? borderCol : 'rgba(255,255,255,0.15)'), background: w ? 'rgba(0,0,0,0.4)' : 'rgba(255,255,255,0.03)', transition: 'background 0.15s, border-color 0.15s' }}>
                    {w ? (
                      <React.Fragment>
                        <div style={{ height: '190px', overflow: 'hidden', position: 'relative', background: 'radial-gradient(ellipse at bottom, ' + (isTarget ? 'rgba(231,76,60,0.2)' : brandColor + '22') + ' 0%, transparent 70%)' }}>
                          <img loading="lazy" src={getWrestlerRender(w) || placeholder} alt={getWrestlerName(w, 'display')}
                            style={{ position: 'absolute', bottom: '-10%', left: '50%', transform: 'translateX(-50%)', height: '240px', width: 'auto', objectFit: 'contain', objectPosition: 'bottom' }} />
                        </div>
                        <div style={{ position: 'absolute', bottom: 0, left: 0, right: 0, padding: '6px 8px 8px', background: 'rgba(0,0,0,0.85)', borderTop: '1px solid ' + (isTarget ? 'rgba(231,76,60,0.4)' : brandColor + '44') }}>
                          <div style={{ fontFamily: "'Anton',sans-serif", fontSize: '0.6rem', letterSpacing: '1px', color: '#fff', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis', marginBottom: '4px' }}>{getWrestlerNameUpper(w, 'display')}</div>
                          <div style={{ display: 'flex', gap: '4px', alignItems: 'center' }}>
                            <img loading="lazy" src={getClassIcon(w.fight_class)} alt="" style={{ width: '14px', height: '14px', objectFit: 'contain' }} onError={e => { e.target.style.display='none'; }} />
                            <img loading="lazy" src={getRoleIcon(w.heel)} alt="" style={{ width: '14px', height: '14px', objectFit: 'contain' }} onError={e => { e.target.style.display='none'; }} />
                            <div style={{ position: 'relative', width: '18px', height: '18px', display: 'inline-flex', alignItems: 'center', justifyContent: 'center' }}>
                              <img loading="lazy" src={getXPBadge(w.starting_xp || 0)} alt="" style={{ position: 'absolute', inset: 0, width: '100%', height: '100%', objectFit: 'contain' }} onError={e => { e.target.style.display='none'; }} />
                              <span style={{ position: 'relative', zIndex: 1, fontFamily: "'Anton',sans-serif", fontSize: '7px', color: '#fff', textShadow: '0 1px 2px rgba(0,0,0,0.9)', lineHeight: 1 }}>{w.starting_xp || 0}</span>
                            </div>
                            {/* Promo skill badge */}
                            <div style={{ display: 'inline-flex', alignItems: 'center', gap: '2px', background: 'rgba(155,89,182,0.15)', border: '1px solid rgba(155,89,182,0.4)', borderRadius: '3px', padding: '1px 4px', fontFamily: "'Monda',sans-serif", fontSize: '0.42rem', color: '#9b59b6', letterSpacing: '0.5px' }} title={'Promo Skill: ' + (w.promo_skill || 1)}>
                              🎤 {w.promo_skill || 1}
                            </div>
                            {/* Match specialist icon */}
                            {isMatchSpecialist(w, matchType) && (
                              <img loading="lazy" src={getMatchSpecialistIcon()} alt="Specialist" title={'Match Specialist: ' + matchType}
                                style={{ width: '18px', height: '18px', objectFit: 'contain', filter: 'drop-shadow(0 0 4px rgba(241,196,15,0.8))' }}
                                onError={e => { e.target.style.display='none'; }} />
                            )}
                            <button onClick={function(e) { e.stopPropagation(); if (isTarget) { var t = [...promoTargets]; t[idx] = null; setPromoTargets(t); } else { var p = [...participants]; p[idx] = null; setParticipants(p); } }}
                              style={{ marginLeft: 'auto', background: 'rgba(231,76,60,0.15)', border: '1px solid rgba(231,76,60,0.4)', color: '#e74c3c', borderRadius: '3px', width: '16px', height: '16px', display: 'flex', alignItems: 'center', justifyContent: 'center', cursor: 'pointer', fontSize: '0.5rem', flexShrink: 0 }}>✕</button>
                          </div>
                        </div>
                      </React.Fragment>
                    ) : (
                      <div style={{ height: '100%', display: 'flex', alignItems: 'center', justifyContent: 'center', flexDirection: 'column', gap: '8px' }}>
                        <div style={{ width: '36px', height: '36px', borderRadius: '50%', border: '1px dashed ' + (isTarget ? 'rgba(231,76,60,0.4)' : 'rgba(255,255,255,0.25)'), display: 'flex', alignItems: 'center', justifyContent: 'center', color: isTarget ? 'rgba(231,76,60,0.5)' : 'rgba(255,255,255,0.3)', fontSize: '1.2rem' }}>+</div>
                        <div style={{ fontFamily: "'Monda',sans-serif", fontSize: '0.4rem', color: isTarget ? 'rgba(231,76,60,0.4)' : 'rgba(255,255,255,0.2)', letterSpacing: '1px' }}>{isTarget ? 'ADD TARGET' : 'CLICK TO ADD'}</div>
                      </div>
                    )}
                  </div>
                );
              };

              var BRAND_LOGOS_BK = {
                'Raw': process.env.PUBLIC_URL + '/brands/logos/RAW25_LOGO.png',
                'SmackDown': process.env.PUBLIC_URL + '/brands/logos/SMACKDOWN25_LOGO.png',
                'NXT': process.env.PUBLIC_URL + '/brands/logos/NXT_LOGO.png',
                'NXT 2.0': process.env.PUBLIC_URL + '/brands/logos/NXT20_LOGO.png',
                'WCW': process.env.PUBLIC_URL + '/brands/logos/WCW_LOGO.png',
                'ECW': process.env.PUBLIC_URL + '/brands/logos/ECW_LOGO.png',
                'NXT Mutiny': process.env.PUBLIC_URL + '/brands/logos/NXTMUTINY_LOGO.png',
              };

              return (
                <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                  {/* Callers */}
                  <div style={{ display: 'flex', gap: '1px' }}>
                    {callerSlots.map(function(w, i) { return renderSlot(w, i, 'caller'); })}
                  </div>
                  {/* Arrow */}
                  {(hasTarget || promoAction === 'invasion') && (
                    <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: '4px', flexShrink: 0, padding: '0 8px' }}>
                      <div style={{ fontFamily: "'Anton',sans-serif", fontSize: '2rem', color: '#e74c3c', textShadow: '0 0 20px rgba(231,76,60,0.8)' }}>→</div>
                    </div>
                  )}
                  {/* Targets */}
                  {hasTarget && (
                    <div style={{ display: 'flex', gap: '1px' }}>
                      {targetSlots.map(function(w, i) { return renderSlot(w, i, 'target'); })}
                    </div>
                  )}
                  {/* Invasion: rival brand target picker */}
                  {promoAction === 'invasion' && (
                    <div style={{ display: 'flex', flexDirection: 'column', gap: '6px' }}>
                      <div style={{ fontFamily: "'Monda',sans-serif", fontSize: '0.38rem', color: 'rgba(255,255,255,0.35)', letterSpacing: '1.5px', textAlign: 'center' }}>TARGET BRAND</div>
                      <div style={{ display: 'flex', gap: '8px', flexWrap: 'wrap' }}>
                        {(rivals || []).filter(Boolean).map(function(r, ri) {
                          var isSelected = promoRivalTarget && promoRivalTarget.brand === r.brand;
                          var rColor = r.color || '#444';
                          var rLogo = BRAND_LOGOS_BK[r.brand] || r.logo || null;
                          var gmRender = r.gm ? GM_RENDERS_MAP[r.gm] : null;
                          return (
                            <div key={ri} onClick={function() { setPromoRivalTarget(isSelected ? null : { brand: r.brand, gm: r.gm, color: rColor, logo: rLogo }); }}
                              style={{ width: '140px', height: '240px', position: 'relative', cursor: 'pointer', borderRadius: '8px', overflow: 'hidden', border: '2px solid ' + (isSelected ? rColor : 'rgba(255,255,255,0.15)'), background: isSelected ? rColor + '18' : 'rgba(255,255,255,0.03)', transition: 'background 0.15s, border-color 0.15s' }}>
                              {/* GM render */}
                              <div style={{ height: '190px', overflow: 'hidden', position: 'relative', background: 'radial-gradient(ellipse at bottom, ' + rColor + '22 0%, transparent 70%)' }}>
                                {gmRender
                                  ? <img loading="lazy" src={gmRender} alt={r.gm}
                                      style={{ position: 'absolute', bottom: '-10%', left: '50%', transform: 'translateX(-50%)', height: '240px', width: 'auto', objectFit: 'contain', objectPosition: 'bottom' }} />
                                  : <div style={{ height: '100%', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                                      <div style={{ fontFamily: "'Anton',sans-serif", fontSize: '0.6rem', color: rColor + '66', letterSpacing: '2px' }}>{r.gm || '?'}</div>
                                    </div>
                                }
                              </div>
                              {/* Brand info bar */}
                              <div style={{ position: 'absolute', bottom: 0, left: 0, right: 0, padding: '6px 8px 8px', background: 'rgba(0,0,0,0.85)', borderTop: '2px solid ' + rColor + '66', display: 'flex', flexDirection: 'column', gap: '4px', alignItems: 'center' }}>
                                {rLogo
                                  ? <img loading="lazy" src={rLogo} alt={r.brand} style={{ height: '22px', objectFit: 'contain', filter: 'drop-shadow(0 0 4px ' + rColor + '88)' }} onError={function(e) { e.target.style.display='none'; }} />
                                  : <div style={{ fontFamily: "'Anton',sans-serif", fontSize: '0.55rem', color: rColor }}>{r.brand.toUpperCase()}</div>
                                }
                                <div style={{ fontFamily: "'Monda',sans-serif", fontSize: '0.38rem', color: 'rgba(255,255,255,0.4)' }}>{r.gm || 'GM'}</div>
                              </div>
                              {isSelected && (
                                <div style={{ position: 'absolute', top: '6px', right: '6px', background: rColor, borderRadius: '50%', width: '18px', height: '18px', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: '0.5rem', color: '#000', fontWeight: 'bold' }}>✓</div>
                              )}
                            </div>
                          );
                        })}
                      </div>
                    </div>
                  )}
                </div>
              );
            })() : teams2.map(function(team, ti) { return (
              <React.Fragment key={ti}>
                {/* VS between teams */}
                {ti > 0 && (
                  <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', padding: '0 16px', flexShrink: 0 }}>
                    <div style={{ fontFamily: "'Anton',sans-serif", fontSize: '2.5rem', color: '#e74c3c', textShadow: '0 0 30px rgba(231,76,60,0.8)', letterSpacing: '4px' }}>VS</div>
                  </div>
                )}
                {/* Team slots */}
                <div style={{ display: 'flex', gap: '1px' }}>
                  {team.map(function(w, wi) {
                    var globalIdx = teams2.slice(0, ti).reduce(function(s, t) { return s + t.length; }, 0) + wi;
                    var tileHasSynergy = w ? (isPromo ? false : hasSynergyWithGroup(w, participants.filter(Boolean))) : false;
                    var tileIsSpecialist = w ? isMatchSpecialist(w, matchType) : false;
                    if (w) {
                      // Brand participant — render brand card instead of wrestler card
                      if (w.isBrand) {
                        var bColor = w.brandColor || BRAND_COLORS[w.brand_id] || '#888';
                        var bLogo  = w.brandLogo  || BRAND_LOGOS_BK_MODULE[w.brand_id];
                        var bBg    = w.brandBg    || BRAND_BG_IMAGES_BK[w.brand_id];
                        return (
                          <div key={wi} style={{ position: 'relative' }}>
                            <div onClick={function() { setPickerIdx(globalIdx); setPickerType('participant'); }}
                              style={{ width: '140px', height: '260px', borderRadius: '8px', overflow: 'hidden', border: '1px solid ' + bColor + '66', background: 'rgba(0,0,0,0.5)', cursor: 'pointer', display: 'flex', flexDirection: 'column', flexShrink: 0 }}>
                              {/* Image area */}
                              <div style={{ height: '200px', position: 'relative', overflow: 'hidden', flexShrink: 0 }}>
                                {bBg
                                  ? <img loading="lazy" src={bBg} alt=""
                                      style={{ position: 'absolute', inset: 0, width: '100%', height: '100%', objectFit: 'cover', objectPosition: 'center top' }}
                                      onError={function(e) { e.target.style.display='none'; }} />
                                  : <div style={{ position: 'absolute', inset: 0, background: bColor + '1a' }} />
                                }
                                <div style={{ position: 'absolute', inset: 0, background: 'radial-gradient(ellipse at center bottom, ' + bColor + '44 0%, rgba(0,0,0,0.55) 70%)' }} />
                                <div style={{ position: 'absolute', inset: 0, display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', gap: '8px' }}>
                                  {bLogo
                                    ? <img loading="lazy" src={bLogo} alt={w.brand_id}
                                        style={{ height: '34px', objectFit: 'contain', filter: 'drop-shadow(0 0 10px ' + bColor + 'bb)', maxWidth: '80%' }}
                                        onError={function(e) { e.target.style.display='none'; }} />
                                    : <span style={{ fontFamily: "'Anton',sans-serif", fontSize: '1rem', color: bColor, letterSpacing: '2px' }}>{w.brand_id}</span>
                                  }
                                  <span style={{ fontFamily: "'Monda',sans-serif", fontSize: '0.34rem', color: bColor + 'bb', letterSpacing: '2px' }}>BRAND</span>
                                </div>
                              </div>
                              {/* Name bar */}
                              <div style={{ flex: 1, display: 'flex', alignItems: 'center', justifyContent: 'center', padding: '4px 6px', background: 'rgba(0,0,0,0.92)', borderTop: '1px solid ' + bColor + '44' }}>
                                <span style={{ fontFamily: "'Anton',sans-serif", fontSize: '0.5rem', color: bColor, letterSpacing: '1px', textAlign: 'center' }}>{w.brand_id.toUpperCase()}</span>
                              </div>
                            </div>
                            <button onClick={function(e) { e.stopPropagation(); var p = [...participants]; p[globalIdx] = null; setParticipants(p); }}
                              style={{ position: 'absolute', top: '8px', left: '8px', zIndex: 20, background: 'rgba(231,76,60,0.9)', border: '1px solid rgba(231,76,60,1)', color: '#fff', borderRadius: '4px', width: '22px', height: '22px', display: 'flex', alignItems: 'center', justifyContent: 'center', cursor: 'pointer', fontSize: '0.7rem', fontWeight: 'bold' }}
                              title="Clear">✕</button>
                          </div>
                        );
                      }
                      return (
                        <div key={wi} style={{ position: 'relative' }}>
                          <UnifiedWrestlerCard
                            wrestler={w}
                            variant="match"
                            brandColor={brandColor}
                            champions={champions}
                            roster={roster}
                            rivalries={rivalries}
                            hasSynergy={tileHasSynergy}
                            isMatchSpecialist={tileIsSpecialist}
                            matchType={matchType}
                            size={{ width: 140, height: 260, renderHeight: 200 }}
                            onClick={function() { setPickerIdx(globalIdx); setPickerType('participant'); }}
                          />
                          {/* Clear button overlaid */}
                          <button onClick={function(e) { e.stopPropagation(); var p = [...participants]; p[globalIdx] = null; setParticipants(p); }}
                            style={{ position: 'absolute', top: '8px', left: '8px', zIndex: 20, background: 'rgba(231,76,60,0.9)', border: '1px solid rgba(231,76,60,1)', color: '#fff', borderRadius: '4px', width: '22px', height: '22px', display: 'flex', alignItems: 'center', justifyContent: 'center', cursor: 'pointer', fontSize: '0.7rem', fontWeight: 'bold' }}
                            title="Clear">✕</button>
                        </div>
                      );
                    }
                    return (
                      <div key={wi} onClick={function() { setPickerIdx(globalIdx); setPickerType('participant'); }}
                        style={{ width: '140px', height: '260px', position: 'relative', cursor: 'pointer', borderRadius: '8px', overflow: 'hidden', border: '1px solid rgba(255,255,255,0.15)', background: 'rgba(255,255,255,0.03)', transition: 'background 0.15s, border-color 0.15s' }}>
                        {/* Empty slot */}
                        <div style={{ height: '100%', display: 'flex', alignItems: 'center', justifyContent: 'center', flexDirection: 'column', gap: '8px' }}>
                          <div style={{ width: '36px', height: '36px', borderRadius: '50%', border: '1px dashed rgba(255,255,255,0.25)', display: 'flex', alignItems: 'center', justifyContent: 'center', color: 'rgba(255,255,255,0.3)', fontSize: '1.2rem' }}>+</div>
                          <div style={{ fontFamily: "'Monda',sans-serif", fontSize: '0.4rem', color: 'rgba(255,255,255,0.2)', letterSpacing: '1px' }}>CLICK TO ADD</div>
                        </div>
                      </div>
                    );
                  })}
                </div>
              </React.Fragment>
            ); })
            }
          </div>
        </div>

        {/* ── BOTTOM SECTION ── */}
        <div style={{ flexShrink: 0, borderTop: '1px solid rgba(255,255,255,0.07)', background: 'rgba(0,0,0,0.4)' }}>

          {/* Title match + Interference row — match only, hidden for inter-brand PLE slots */}
          {!isPromo && !disableTitleMatch && <div style={{ padding: '12px 24px', display: 'flex', gap: '16px', alignItems: 'center' }}>

            {/* Title Match — dropdown if no champ, checkbox if champ */}
            <div style={{ flex: 1 }}>
              {champInMatch && !multipleChampSlots && champMatchSlot ? (
                /* Single champion → Checkbox */
                <div style={{ display: 'flex', alignItems: 'center', gap: '12px', padding: '8px 14px', background: 'rgba(212,175,55,0.06)', border: '1px solid rgba(212,175,55,0.25)', borderRadius: '6px', cursor: 'pointer' }}
                  onClick={() => setTitleMatch(titleMatch === champMatchSlot.key ? null : champMatchSlot.key)}>
                  <div style={{ width: '20px', height: '20px', borderRadius: '3px', border: '1px solid ' + (titleMatch === champMatchSlot.key ? '#d4af37' : 'rgba(255,255,255,0.25)'), background: titleMatch === champMatchSlot.key ? '#d4af37' : 'transparent', display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0, transition: 'background 0.15s, border-color 0.15s, color 0.15s' }}>
                    {titleMatch === champMatchSlot.key && <span style={{ color: '#000', fontSize: '0.55rem', fontWeight: 'bold' }}>✓</span>}
                  </div>
                  {champMatchSlot.titleOverride && (
                    <img loading="lazy" src={(champMatchSlot.titleOverride && champMatchSlot.titleOverride.render) || getTitleRender(champMatchSlot.titleOverride && champMatchSlot.titleOverride.id) || placeholderTitle} alt="" style={{ height: '28px', objectFit: 'contain', filter: 'drop-shadow(0 0 6px rgba(212,175,55,0.6))' }} onError={e => { e.target.style.display='none'; }} />
                  )}
                  <div>
                    <div style={{ fontFamily: "'Monda',sans-serif", fontSize: '0.44rem', color: 'rgba(255,255,255,0.4)', letterSpacing: '1px' }}>TITLE ON THE LINE</div>
                    <div style={{ fontFamily: "'Anton',sans-serif", fontSize: '0.6rem', color: titleMatch === champMatchSlot.key ? '#d4af37' : 'rgba(255,255,255,0.6)', letterSpacing: '1px' }}>
                      {champMatchSlot.titleOverride ? champMatchSlot.titleOverride.name : champMatchSlot.key}
                    </div>
                  </div>
                </div>
              ) : champInMatch && multipleChampSlots ? (
                /* Multiple champions → Dropdown with only their titles */
                <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                  <div style={{ fontFamily: "'Monda',sans-serif", fontSize: '0.44rem', color: 'rgba(255,255,255,0.4)', letterSpacing: '1.5px', flexShrink: 0 }}>TITLE ON THE LINE</div>
                  <select style={{ ...S.input, flex: 1, colorScheme: 'dark' }} value={titleMatch || ''} onChange={e => setTitleMatch(e.target.value || null)}>
                    <option value="">No Title</option>
                    {champSlotsInMatch.map(function(s) {
                      var titleName = (s.titleOverride && s.titleOverride.name) || s.key;
                      return <option key={s.key} value={s.key}>⚔️ {titleName}</option>;
                    })}
                  </select>
                </div>
              ) : (
                /* Dropdown when no champion */
                <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                  <div style={{ fontFamily: "'Monda',sans-serif", fontSize: '0.44rem', color: 'rgba(255,255,255,0.4)', letterSpacing: '1.5px', flexShrink: 0 }}>TITLE MATCH</div>
                  <select style={{ ...S.input, flex: 1, colorScheme: 'dark' }} value={titleMatch || ''} onChange={e => setTitleMatch(e.target.value || null)}>
                    <option value="">No Title</option>
                    {(() => {
                      var slots = champions && champions.slots || [];
                      var champMap3 = champions && champions.champions || {};
                      var isTagRule = matchRule === 'tag' || matchRule === 'tag-triple-threat' || matchRule === 'tag-fatal-4-way' || matchRule === '3v3' || matchRule === '4v4';
                      return slots.filter(function(s) {
                        // Solo match → only solo titles; Tag match → only tag titles
                        return isTagRule ? !!s.isTagTeam : !s.isTagTeam;
                      }).map(function(s) {
                        var champs = champMap3[s.key];
                        var hasChamp = champs && champs.length > 0 && champs[0];
                        var champName = hasChamp ? champs.map(function(c) { return getWrestlerName(c, 'display'); }).join(' & ') : 'VACANT';
                        var titleName = (s.titleOverride && s.titleOverride.name) || s.label || s.key;
                        var champInMatchLocal = hasChamp && champs.some(function(c) { return participants.find(function(p) { return p && p.wrestler_id === c.wrestler_id; }); });
                        var isVacant = !hasChamp;
                        var isSelectable = isVacant || champInMatchLocal;
                        return <option key={s.key} value={s.key} disabled={!isSelectable}>{isVacant ? '🏆 ' : champInMatchLocal ? '⚔️ ' : '🔒 '}{titleName} — {champName}</option>;
                      });
                    })()}
                  </select>
                </div>
              )}
            </div>

            {/* Interference button */}
            <button onClick={() => setInterference(showInterference ? 'none' : 'superstar')}
              style={{ fontFamily: "'Monda',sans-serif", fontSize: '0.48rem', letterSpacing: '1.5px', background: showInterference ? 'rgba(231,76,60,0.15)' : 'transparent', border: '1px solid ' + (showInterference ? 'rgba(231,76,60,0.6)' : 'rgba(255,255,255,0.2)'), color: showInterference ? '#e74c3c' : 'rgba(255,255,255,0.5)', padding: '10px 20px', borderRadius: '5px', cursor: 'pointer', transition: 'background 0.15s, border-color 0.15s, color 0.15s', flexShrink: 0 }}>
              INTERFERENCE
            </button>
          </div>}

          {/* Interference panel — match only */}
          {!isPromo && showInterference && (
            <div style={{ padding: '0 24px 14px' }}>
              <div style={{ background: 'rgba(231,76,60,0.06)', border: '1px solid rgba(231,76,60,0.2)', borderRadius: '8px', padding: '12px 16px' }}>
                <div style={{ display: 'flex', alignItems: 'center', gap: '12px', marginBottom: '12px' }}>
                  {/* SUPERSTARS / GM tabs */}
                  <div style={{ display: 'flex', gap: '4px' }}>
                    {['superstar', 'gm'].map(function(type) { return (
                      <button key={type} onClick={() => setInterference(type)}
                        style={{ fontFamily: "'Monda',sans-serif", fontSize: '0.44rem', letterSpacing: '1px', background: interference === type ? 'rgba(231,76,60,0.2)' : 'transparent', border: '1px solid ' + (interference === type ? 'rgba(231,76,60,0.6)' : 'rgba(255,255,255,0.15)'), color: interference === type ? '#e74c3c' : 'rgba(255,255,255,0.4)', padding: '5px 14px', borderRadius: '4px', cursor: 'pointer' }}>
                        {type === 'superstar' ? 'SUPERSTARS' : 'GM'}
                      </button>
                    ); })}
                  </div>
                  <button onClick={() => { setInterference('none'); setInterferenceA(null); setInterferenceB(null); }}
                    style={{ marginLeft: 'auto', fontFamily: "'Monda',sans-serif", fontSize: '0.4rem', background: 'transparent', border: 'none', color: 'rgba(255,255,255,0.3)', cursor: 'pointer', letterSpacing: '1px' }}>← CLEAR</button>
                </div>

                <div style={{ display: 'flex', alignItems: 'center', gap: '16px' }}>
                  {/* Attacker */}
                  <div style={{ display: 'flex', flexDirection: 'column', gap: '4px' }}>
                    <div style={{ fontFamily: "'Monda',sans-serif", fontSize: '0.38rem', color: 'rgba(255,255,255,0.35)', letterSpacing: '1.5px' }}>ATTACKER</div>
                    {interference === 'gm' ? (
                      <div style={{ padding: '8px 14px', background: 'rgba(255,255,255,0.05)', border: '1px solid rgba(255,255,255,0.1)', borderRadius: '6px', fontFamily: "'Monda',sans-serif", fontSize: '0.48rem', color: 'rgba(255,255,255,0.6)' }}>
                        {gmName || 'GM'}
                      </div>
                    ) : (
                      <div onClick={() => { setPickerIdx(200); setPickerType('intA'); }}
                        style={{ display: 'flex', alignItems: 'center', gap: '8px', padding: '6px 12px', background: interferenceA ? 'rgba(231,76,60,0.08)' : 'rgba(255,255,255,0.03)', border: '1px solid ' + (interferenceA ? 'rgba(231,76,60,0.4)' : 'rgba(255,255,255,0.12)'), borderRadius: '6px', cursor: 'pointer', minWidth: '160px' }}>
                        {interferenceA ? (
                          <React.Fragment>
                            <img loading="lazy" src={getWrestlerRender(interferenceA) || placeholder} alt="" style={{ width: '28px', height: '36px', objectFit: 'contain', objectPosition: 'top' }} />
                            <div style={{ fontFamily: "'Anton',sans-serif", fontSize: '0.52rem', color: '#fff' }}>{getWrestlerNameUpper(interferenceA, 'display')}</div>
                          </React.Fragment>
                        ) : (
                          <div style={{ fontFamily: "'Monda',sans-serif", fontSize: '0.44rem', color: 'rgba(255,255,255,0.3)', letterSpacing: '0.5px' }}>+ SELECT ATTACKER</div>
                        )}
                      </div>
                    )}
                  </div>

                  {/* Arrow */}
                  <div style={{ fontFamily: "'Anton',sans-serif", fontSize: '1.2rem', color: '#e74c3c', marginTop: '16px' }}>→</div>

                  {/* Target */}
                  <div style={{ display: 'flex', flexDirection: 'column', gap: '4px' }}>
                    <div style={{ fontFamily: "'Monda',sans-serif", fontSize: '0.38rem', color: 'rgba(255,255,255,0.35)', letterSpacing: '1.5px' }}>TARGET</div>
                    <select style={{ ...S.input, minWidth: '180px', colorScheme: 'dark' }} value={interferenceB ? (interferenceB === 'any' ? 'any' : interferenceB.wrestler_id) : ''}
                      onChange={e => {
                        if (!e.target.value) { setInterferenceB(null); return; }
                        if (e.target.value === 'any') { setInterferenceB('any'); return; }
                        var found = participants.filter(Boolean).find(function(p) { return String(p.wrestler_id) === e.target.value; });
                        if (found) setInterferenceB(found);
                      }}>
                      <option value="">Select target...</option>
                      {participants.filter(Boolean).map(function(p, i) { return (
                        <option key={i} value={p.wrestler_id}>{p.name}</option>
                      ); })}
                      <option value="any">Any participant</option>
                    </select>
                  </div>
                </div>
              </div>
            </div>
          )}
          {!isPromo && <span />}

          {/* Footer buttons */}
          <div style={{ padding: '12px 24px 16px', display: 'flex', justifyContent: 'space-between', alignItems: 'center', borderTop: '1px solid rgba(255,255,255,0.06)' }}>
            <div style={{ display: 'flex', flexDirection: 'column', gap: '4px' }}>
              {disableTitleMatch ? (
                <span style={{ fontFamily: "'Monda',sans-serif", fontSize: '0.44rem', color: 'rgba(255,255,255,0.25)', letterSpacing: '1px' }}>INTER-BRAND — NO COST</span>
              ) : (
                <>
                  <div style={{ display: 'flex', alignItems: 'center', gap: '6px' }}>
                    {editingCost ? (
                      <>
                        <span style={{ fontFamily: "'Monda',sans-serif", fontSize: '0.44rem', color: 'rgba(255,255,255,0.35)', letterSpacing: '1px' }}>$</span>
                        <input
                          type="number"
                          value={costInput}
                          onChange={e => setCostInput(e.target.value)}
                          onKeyDown={e => {
                            if (e.key === 'Enter') {
                              var parsed = parseInt(costInput, 10);
                              if (!isNaN(parsed) && parsed >= 0) setCostOverride(parsed);
                              else setCostOverride(null);
                              setEditingCost(false);
                            }
                            if (e.key === 'Escape') { setEditingCost(false); }
                          }}
                          autoFocus
                          style={{ background: 'rgba(255,255,255,0.08)', border: '1px solid rgba(212,175,55,0.5)', borderRadius: '3px', padding: '3px 8px', color: '#d4af37', fontSize: '0.5rem', fontFamily: "'Monda',sans-serif", outline: 'none', width: '100px' }}
                        />
                        <button onClick={() => {
                          var parsed = parseInt(costInput, 10);
                          if (!isNaN(parsed) && parsed >= 0) setCostOverride(parsed);
                          else setCostOverride(null);
                          setEditingCost(false);
                        }} style={{ background: 'rgba(212,175,55,0.15)', border: '1px solid rgba(212,175,55,0.4)', borderRadius: '3px', padding: '3px 8px', color: '#d4af37', fontSize: '0.44rem', fontFamily: "'Monda',sans-serif", cursor: 'pointer' }}>✓</button>
                        {costOverride !== null && (
                          <button onClick={() => { setCostOverride(null); setEditingCost(false); }} style={{ background: 'transparent', border: '1px solid rgba(231,76,60,0.35)', borderRadius: '3px', padding: '3px 8px', color: 'rgba(231,76,60,0.6)', fontSize: '0.44rem', fontFamily: "'Monda',sans-serif", cursor: 'pointer' }}>RESET</button>
                        )}
                      </>
                    ) : (
                      <>
                        <span style={{ fontFamily: "'Anton',sans-serif", fontSize: '0.75rem', color: costOverride !== null ? '#d4af37' : 'rgba(255,255,255,0.5)', letterSpacing: '1px' }}>
                          ${(costOverride !== null ? costOverride : baseDisplayCost).toLocaleString('fr-FR')}
                        </span>
                        {costOverride !== null && (
                          <span style={{ fontFamily: "'Monda',sans-serif", fontSize: '0.38rem', color: 'rgba(255,255,255,0.25)', textDecoration: 'line-through', letterSpacing: '0.5px' }}>${baseDisplayCost.toLocaleString('fr-FR')}</span>
                        )}
                        <button onClick={() => { setCostInput(costOverride !== null ? String(costOverride) : String(baseDisplayCost)); setEditingCost(true); }}
                          style={{ background: 'transparent', border: 'none', color: 'rgba(255,255,255,0.3)', fontSize: '0.5rem', cursor: 'pointer', padding: '0 2px', lineHeight: 1 }}
                          title="Edit match cost">✏</button>
                      </>
                    )}
                  </div>
                  {mixedGenderCost > 0 && <span style={{ fontFamily: "'Monda',sans-serif", fontSize: '0.44rem', color: '#9b59b6' }}>+$5,000 mixed gender</span>}
                  {interference !== 'none' && INTERFERENCE_COST[interference] && (
                    <span style={{ fontFamily: "'Monda',sans-serif", fontSize: '0.44rem', color: 'rgba(255,255,255,0.35)' }}>incl. +${INTERFERENCE_COST[interference].toLocaleString('fr-FR')} interference</span>
                  )}
                </>
              )}
            </div>
            <div style={{ display: 'flex', gap: '10px' }}>
              <button className="btn-wwe" style={S.btn} onClick={onClose}>CANCEL</button>
              <button className="btn-wwe"
                onClick={() => {
                  if (interference === 'superstar' && (!interferenceA || !interferenceB)) return;
                  if (interference === 'gm' && !interferenceB) return;
                  var baseMatchCost = disableTitleMatch ? 0 : baseDisplayCost;
                  onSave({
                    matchRule, matchType,
                    participants: participants.filter(Boolean),
                    titleMatch, interference,
                    guestReferee: isSpecialGuestRef ? guestReferee : null,
                    interferenceA: interference === 'gm' ? { name: gmName } : interferenceA,
                    interferenceB,
                    promoAction: isPromo ? promoAction : null,
                    promoTargets: isPromo ? promoTargets : [],
                    promoRivalTarget: isPromo ? promoRivalTarget : null,
                    costOverride: costOverride !== null ? costOverride : null,
                    cost: costOverride !== null ? costOverride : baseMatchCost,
                  });
                  onClose();
                }}
                disabled={
                  (isPromo && !promoAction) ||
                  (isPromo && participants.filter(Boolean).length === 0) ||
                  (!isPromo && interference === 'superstar' && (!interferenceA || !interferenceB)) ||
                  (!isPromo && interference === 'gm' && !interferenceB)
                }
                style={{ ...S.btn, borderColor: ((interference === 'superstar' && (!interferenceA || !interferenceB)) || (interference === 'gm' && !interferenceB)) ? 'rgba(255,255,255,0.15)' : 'rgba(255,255,255,0.55)', color: ((interference === 'superstar' && (!interferenceA || !interferenceB)) || (interference === 'gm' && !interferenceB)) ? 'rgba(255,255,255,0.25)' : '#fff', cursor: ((interference === 'superstar' && (!interferenceA || !interferenceB)) || (interference === 'gm' && !interferenceB)) ? 'not-allowed' : 'pointer' }}>
                CONFIRM
              </button>
            </div>
          </div>

        </div>
      </div>
    </div>
  );
};

// ── Slot Card (left panel) ──────────────────────────────────────────
const SlotCard = ({ slot, isSelected, brandColor, onClick, onDoubleClick, isMainEvent, champions }) => {
  const hasBooking = slot.booking && slot.booking.participants?.length > 0;
  const slotColor = SLOT_COLORS[slot.type] || '#fff';
  const isPromo = slot.type === 'promo';

  return (
    <div className={`slot-card${isSelected ? ' selected' : ''}`} onClick={onClick} onDoubleClick={onDoubleClick}
      style={{ borderRadius: '6px', overflow: 'hidden', border: `1px solid ${isSelected ? 'rgba(255,255,255,0.6)' : 'rgba(255,255,255,0.08)'}`, background: isSelected ? 'rgba(255,255,255,0.06)' : 'rgba(8,8,8,0.8)', position: 'relative', minHeight: isMainEvent ? '180px' : '115px', display: 'flex', flexDirection: 'column', cursor: 'pointer' }}>
      {/* Top label */}
      <div style={{ padding: '5px 8px', background: isSelected ? `${slotColor}22` : 'rgba(0,0,0,0.5)', borderBottom: '1px solid rgba(255,255,255,0.05)', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
        <div style={{ ...S.anton, fontSize: '0.65rem', letterSpacing: '1.5px', color: slotColor }}>{SLOT_LABELS[slot.type]}</div>
        {hasBooking && !isPromo && (
          <div style={{ display: 'flex', alignItems: 'center', gap: '6px' }}>
            {slot.booking.titleMatch && (
              <img
                src={(() => {
                  var champSlots = (champions && champions.slots) || [];
                  var s = champSlots.find(function(sl) { return sl.key === slot.booking.titleMatch; });
                  var tid = s && s.titleOverride && s.titleOverride.id;
                  // Check titleOverride for custom render first
                  if (s && s.titleOverride && s.titleOverride.render) return s.titleOverride.render;
                  return tid ? getTitleRender(tid) : placeholderTitle;
                })()}
                alt=""
                onError={function(e) { e.target.src = placeholderTitle; }}
                style={{ height: '22px', objectFit: 'contain', filter: 'drop-shadow(0 0 6px rgba(212,175,55,0.8))' }}
              />
            )}
            <div style={{ ...S.mono, fontSize: '0.65rem', color: '#d4af37' }}>${(slot.booking.cost || 0).toLocaleString('fr-FR')}</div>
          </div>
        )}
      </div>

      {/* Content */}
      <div style={{ flex: 1, padding: '6px 8px', display: 'flex', alignItems: 'center', gap: '6px' }}>
        {hasBooking ? (
          isPromo ? (
            <div style={{ display: 'flex', alignItems: 'center', gap: '8px', flex: 1, overflow: 'hidden' }}>
              <img
                src={getWrestlerRender(slot.booking.participants[0]) || placeholder}
                alt=""
                style={{ height: isMainEvent ? '100px' : '70px', objectFit: 'contain', objectPosition: 'top', filter: 'drop-shadow(0 2px 6px rgba(0,0,0,0.8))', flexShrink: 0 }}
              />
              <div style={{ display: 'flex', flexDirection: 'column', gap: '3px', overflow: 'hidden' }}>
                {slot.booking.promoAction && (
                  <div style={{ ...S.anton, fontSize: '0.52rem', letterSpacing: '1px', color: '#d4af37' }}>
                    {(PROMO_ACTIONS.find(function(a) { return a.id === slot.booking.promoAction; }) || {}).name || ''}
                  </div>
                )}
                <div style={{ ...S.mono, fontSize: '0.48rem', color: '#fff', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>
                  {slot.booking.participants[0] ? slot.booking.participants[0].name : 'Promo set'}
                </div>
                {slot.booking.cost > 0 && (
                  <div style={{ ...S.mono, fontSize: '0.44rem', color: '#d4af37' }}>${slot.booking.cost.toLocaleString('fr-FR')}</div>
                )}
              </div>
            </div>
          ) : (
            <div style={{ display: 'flex', flexDirection: 'column', flex: 1, gap: '4px' }}>
              <div style={{ display: 'flex', alignItems: 'center', gap: '4px' }}>
                {(() => {
                  var matchRule = slot.booking.matchRule || '1v1';
                  var teamSizes = RULE_TEAMS[matchRule] || [1, 1];
                  var allP = slot.booking.participants;
                  var maxShow = isMainEvent ? 4 : 2;
                  var teams = [];
                  var idx = 0;
                  teamSizes.forEach(function(size) {
                    teams.push(allP.slice(idx, idx + size));
                    idx += size;
                  });
                  return teams.map(function(team, ti) {
                    var shownTeam = team.slice(0, maxShow);
                    return (
                      React.createElement(React.Fragment, { key: ti },
                        ti > 0 && React.createElement('div', { style: { ...S.anton, fontSize: '0.5rem', color: '#e74c3c', flexShrink: 0 } }, 'VS'),
                        React.createElement('div', { style: { display: 'flex', flexDirection: 'column', alignItems: 'center', gap: '2px' } },
                          React.createElement('div', { style: { display: 'flex', gap: '4px', alignItems: 'flex-end' } },
                            shownTeam.map(function(w, wi) {
                              return React.createElement(React.Fragment, { key: wi },
                                wi > 0 && React.createElement('div', { style: { ...S.mono, fontSize: '0.4rem', color: 'rgba(255,255,255,0.4)', alignSelf: 'center' } }, '&'),
                                React.createElement('img', { src: getWrestlerRender(w) || placeholder, alt: '', style: { height: isMainEvent ? '130px' : '80px', objectFit: 'contain', objectPosition: 'top', filter: 'drop-shadow(0 2px 6px rgba(0,0,0,0.8))' } })
                              );
                            })
                          ),
                          React.createElement('div', { style: { ...S.mono, fontSize: '0.4rem', color: 'rgba(255,255,255,0.6)', whiteSpace: 'nowrap', maxWidth: '120px', overflow: 'hidden', textOverflow: 'ellipsis', textAlign: 'center' } },
                            shownTeam.map(function(w) { return w ? getWrestlerNameUpper(w, 'display') : ''; }).filter(Boolean).join(' & ')
                          )
                        )
                      )
                    );
                  });
                })()}
              </div>
              <div style={{ display: 'flex', gap: '6px', flexWrap: 'wrap' }}>
                {slot.booking.matchRule && slot.booking.matchRule !== '1v1' && (
                  <div style={{ ...S.mono, fontSize: '0.38rem', color: 'rgba(255,255,255,0.5)', background: 'rgba(255,255,255,0.06)', padding: '1px 5px', borderRadius: '3px' }}>
                    {MATCH_RULES.find(r => r.id === slot.booking.matchRule)?.name}
                  </div>
                )}
                {slot.booking.matchType && (
                  <div style={{ ...S.mono, fontSize: '0.36rem', color: 'rgba(255,255,255,0.35)', background: 'rgba(255,255,255,0.04)', padding: '1px 5px', borderRadius: '3px' }}>
                    {MATCH_TYPES.find(m => m.id === slot.booking.matchType)?.name}
                  </div>
                )}
              </div>
            </div>
          )
        ) : (
          <div style={{ ...S.mono, fontSize: '0.6rem', color: 'rgba(255,255,255,0.2)', letterSpacing: '1px' }}>
            {isPromo ? '+ ADD PROMO' : '+ BOOK MATCH'}
          </div>
        )}
      </div>
    </div>
  );
};

// ── Center Preview ──────────────────────────────────────────────────
export const SlotPreview = ({ slot, brandColor, brandBg, onEdit, onClear, champions, roster, rivalries }) => {
  const participantScrollRef = React.useRef(null);
  const [showScrollArrows, setShowScrollArrows] = React.useState(false);

  React.useEffect(function() {
    var el = participantScrollRef.current;
    if (!el) return;
    var check = function() { setShowScrollArrows(el.scrollWidth > el.clientWidth + 4); };
    check();
    var ro = new ResizeObserver(check);
    ro.observe(el);
    return function() { ro.disconnect(); };
  }, [slot]);

  const scrollParticipants = function(dir) {
    if (participantScrollRef.current) participantScrollRef.current.scrollBy({ left: dir * 160, behavior: 'smooth' });
  };

  if (!slot) return (
    <div style={{ flex: 1, display: 'flex', alignItems: 'center', justifyContent: 'center', ...S.mono, fontSize: '0.6rem', color: 'rgba(255,255,255,0.15)', letterSpacing: '2px' }}>
      SELECT A SLOT
    </div>
  );

  const hasBooking = slot.booking?.participants?.length > 0;
  const slotColor = SLOT_COLORS[slot.type] || '#fff';
  const p = slot.booking?.participants || [];

  return (
    <div style={{ display: 'flex', flexDirection: 'column', overflow: 'hidden' }}>
      {/* Slot title */}
      <div style={{ padding: '0 0 12px', display: 'flex', alignItems: 'baseline', gap: '10px', flexWrap: 'wrap' }}>
        <div style={{ ...S.anton, fontSize: '1.8rem', letterSpacing: '3px', color: slotColor }}>{SLOT_LABELS[slot.type]}</div>
        {slot.type === 'promo' ? (slot.booking && slot.booking.promoAction ? <div style={{ ...S.mono, fontSize: '0.7rem', color: '#d4af37', letterSpacing: '1px' }}>{(PROMO_ACTIONS.find(function(a) { return a.id === slot.booking.promoAction; }) || {}).name || ''}</div> : null) : (slot.booking && slot.booking.matchType ? <div style={{ ...S.mono, fontSize: '0.7rem', color: 'rgba(255,255,255,0.4)', letterSpacing: '1px' }}>{(MATCH_TYPES.find(function(m) { return m.id === slot.booking.matchType; }) || {}).name || ''}</div> : null)}
        {/* Rivalries in preview — all rivalries where all members are present */}
        {slot.booking && slot.type !== 'promo' && slot.booking.participants && (() => {
          var allRvs = detectAllRivalries(slot.booking.participants, rivalries || []);
          if (allRvs.length === 0) return null;
          return (
            <div style={{ display: 'flex', flexWrap: 'wrap', gap: '5px' }}>
              {allRvs.map(function(rv) {
                var lvlColor = RIVALRY_LEVEL_COLORS[rv.level] || '#e74c3c';
                // Build side names from roster
                var getSideName = function(sideIds) {
                  return (sideIds || []).map(function(id) {
                    var w = (roster || []).find(function(r) { return String(r.wrestler_id) === String(id); });
                    return w ? getWrestlerName(w, 'display') : '?';
                  }).filter(Boolean).join(' & ');
                };
                var s1Name = rv.teamName1 || getSideName(rv.side1);
                var s2Name = rv.teamName2 || getSideName(rv.side2);
                return (
                  <div key={rv.id} style={{ display: 'flex', alignItems: 'center', gap: '5px', padding: '3px 10px', borderRadius: '3px', background: lvlColor + '18', border: '1px solid ' + lvlColor + '55' }}>
                    <div style={{ display: 'flex', gap: '2px' }}>
                      {[1,2,3,4].map(l => <div key={l} style={{ width: '8px', height: '3px', borderRadius: '1px', background: l <= rv.level ? lvlColor : 'rgba(255,255,255,0.1)' }} />)}
                    </div>
                    <span style={{ fontFamily: "'Monda',sans-serif", fontSize: '0.4rem', color: lvlColor, letterSpacing: '0.5px' }}>
                      {s1Name} <span style={{ opacity: 0.6 }}>vs</span> {s2Name}
                    </span>
                  </div>
                );
              })}
            </div>
          );
        })()}
      </div>

      {/* Participants preview */}
      {hasBooking && slot.type !== 'promo' ? (
        <div style={{ flex: 1, display: 'flex', flexDirection: 'column', overflow: 'hidden', position: 'relative', minHeight: 0, alignItems: 'center', justifyContent: 'center', borderRadius: '8px', border: slot.booking && slot.booking.titleMatch ? '2px solid rgba(212,175,55,0.6)' : 'none', boxShadow: slot.booking && slot.booking.titleMatch ? '0 0 20px rgba(212,175,55,0.25), inset 0 0 20px rgba(212,175,55,0.06)' : 'none' }}>
          {brandBg && <img loading="lazy" src={brandBg} alt="" style={{ position: 'absolute', inset: 0, width: '100%', height: '100%', objectFit: 'cover', filter: 'blur(8px) brightness(0.25)', zIndex: 0 }} />}
          <div style={{ position: 'absolute', inset: 0, background: `radial-gradient(ellipse at center, ${brandColor}15 0%, transparent 70%)`, zIndex: 1 }} />
          {/* Title belt */}
          {slot.booking && slot.booking.titleMatch && (
            <div style={{ position: 'absolute', top: '12px', left: '50%', transform: 'translateX(-50%)', zIndex: 3, display: 'flex', flexDirection: 'column', alignItems: 'center', gap: '8px' }}>
              {(() => {
                // slot.booking.titleMatch = slot key (e.g. 'male-world')
                // Look in champions.slots for the titleOverride
                var champSlots = (champions && champions.slots) || [];
                var slotData = champSlots.find(function(sl) { return sl.key === slot.booking.titleMatch; });
                // Get title id from titleOverride on the brand's slot
                var titleId = slotData && slotData.titleOverride && slotData.titleOverride.id;
                // Get name — prioritize TITLES_DATABASE, then titleOverride.name, then slot key
                var dbTitle = titleId && TITLES_DATABASE.find(function(t) { return t.id === titleId; });
                var titleName = (dbTitle && dbTitle.name) || (slotData && slotData.titleOverride && slotData.titleOverride.name) || slot.booking.titleMatch;
                // Prioritize uploaded render (base64 for custom titles), then public URL, then placeholder
                var storedRender = slotData && slotData.titleOverride && slotData.titleOverride.render;
                var render = storedRender || (titleId ? getTitleRender(titleId) : placeholderTitle);
                return (
                  <>
                    <img loading="lazy" src={render} alt=""
                      onError={function(e) { e.target.src = placeholderTitle; }}
                      style={{ height: '100px', objectFit: 'contain', filter: 'drop-shadow(0 0 16px rgba(212,175,55,0.9)) drop-shadow(0 0 32px rgba(212,175,55,0.6))' }} />
                    <div style={{ textAlign: 'center' }}>
                      <div style={{ fontFamily: "'Anton',sans-serif", fontSize: '1rem', letterSpacing: '2px', color: '#d4af37', textShadow: '0 0 12px rgba(212,175,55,0.8)', marginBottom: '2px' }}>
                        {titleName.toUpperCase()}
                      </div>
                      <div style={{ fontFamily: "'Anton',sans-serif", fontSize: '1rem', letterSpacing: '2px', color: 'rgba(212,175,55,0.6)' }}>MATCH</div>
                    </div>
                  </>
                );
              })()}
            </div>
          )}
          {/* Individual wrestler cells — scrollable if overflow */}
          {(() => {
            const teams = groupIntoTeams(p, slot?.booking?.matchRule || '1v1');
            const totalMembers = p.length;
            const cardH = 330;
            const hasTitleMatch = !!(slot.booking && slot.booking.titleMatch);
            return (
              <div style={{ position: 'relative', zIndex: 2, width: '100%', paddingTop: hasTitleMatch ? '220px' : '0' }}>
                {/* Left arrow — only shown when content overflows */}
                {showScrollArrows && (
                  <button onClick={function() { scrollParticipants(-1); }} style={{ position: 'absolute', left: '4px', top: '50%', transform: 'translateY(-50%)', zIndex: 10, background: 'rgba(0,0,0,0.65)', border: '1px solid rgba(255,255,255,0.15)', color: '#fff', borderRadius: '50%', width: '28px', height: '28px', cursor: 'pointer', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: '0.7rem', flexShrink: 0 }}>‹</button>
                )}
                {/* Scrollable row */}
                <div ref={participantScrollRef} style={{ display: 'flex', alignItems: 'center', justifyContent: showScrollArrows ? 'flex-start' : 'center', padding: '16px', gap: 0, overflowX: 'auto', WebkitOverflowScrolling: 'touch', scrollbarWidth: 'none', msOverflowStyle: 'none' }}>
                  <style>{'.bp-scroll::-webkit-scrollbar{display:none}'}</style>
                  <div className="bp-scroll" style={{ display: 'flex', alignItems: 'center', gap: 0, flexShrink: 0 }}>
                    {teams.map(function(team, ti) { return (
                      <React.Fragment key={ti}>
                        {ti > 0 && (
                          <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', padding: '0 12px', flexShrink: 0 }}>
                            <span style={{ fontFamily: "'Anton',sans-serif", fontSize: '2rem', color: '#e74c3c', textShadow: '0 0 20px rgba(231,76,60,0.8)' }}>VS</span>
                          </div>
                        )}
                        <div style={{ display: 'flex', gap: '1px' }}>
                          {team.map(function(w, wi) { 
                            var previewHasSynergy = slot?.type === 'promo' ? false : hasSynergyWithGroup(w, p);
                            var previewIsSpecialist = isMatchSpecialist(w, slot?.booking?.matchType);
                            var champSlotsP = (champions && champions.slots) || [];
                            var champMapP = (champions && champions.champions) || {};
                            var previewIsChamp = champSlotsP.some(function(cs) {
                              var champs = champMapP[cs.key] || [];
                              return champs.some(function(c) { return c && String(c.wrestler_id) === String(w.wrestler_id); });
                            });
                            return (
                              <UnifiedWrestlerCard
                                key={wi}
                                wrestler={w}
                                variant="preview"
                                brandColor={brandColor}
                                champions={champions}
                                roster={roster}
                                rivalries={rivalries}
                                hasSynergy={previewHasSynergy}
                                isMatchSpecialist={previewIsSpecialist}
                                isChampionGlow={previewIsChamp}
                                isSpecialistGlow={previewIsSpecialist && !previewIsChamp}
                                matchType={slot?.booking?.matchType}
                                size={{ width: 143, height: cardH, renderHeight: 264 }}
                              />
                            );
                          })}
                        </div>
                      </React.Fragment>
                    ); })}
                  </div>
                </div>
                {/* Right arrow — only shown when content overflows */}
                {showScrollArrows && (
                  <button onClick={function() { scrollParticipants(1); }} style={{ position: 'absolute', right: '4px', top: '50%', transform: 'translateY(-50%)', zIndex: 10, background: 'rgba(0,0,0,0.65)', border: '1px solid rgba(255,255,255,0.15)', color: '#fff', borderRadius: '50%', width: '28px', height: '28px', cursor: 'pointer', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: '0.7rem', flexShrink: 0 }}>›</button>
                )}
              </div>
            );
          })()}
        </div>
      ) : hasBooking && slot.type === 'promo' ? (
        <div style={{ flex: 1, display: 'flex', overflow: 'hidden', position: 'relative', minHeight: 0 }}>
          {brandBg && <img loading="lazy" src={brandBg} alt="" style={{ position: 'absolute', inset: 0, width: '100%', height: '100%', objectFit: 'cover', filter: 'blur(8px) brightness(0.25)', zIndex: 0 }} />}
          <div style={{ position: 'absolute', inset: 0, background: 'radial-gradient(ellipse at center, rgba(212,175,55,0.1) 0%, transparent 70%)', zIndex: 1 }} />
          {(() => {
            var promoData = slot.booking.promoAction ? PROMO_ACTIONS.find(function(a) { return a.id === slot.booking.promoAction; }) : null;
            var promoTargets = slot.booking.promoTargets || [];
            var promoRivalTarget = slot.booking.promoRivalTarget;
            var hasTargets = promoTargets.length > 0;
            var hasInvasion = slot.booking.promoAction === 'invasion' && promoRivalTarget;
            var showArrow = hasTargets || hasInvasion;

            var renderStar = function(w, borderColor, glowColor) {
              if (!w) return null;
              var champSlotsPromo = (champions && champions.slots) || [];
              var champMapPromo = (champions && champions.champions) || {};
              var promoIsChamp = champSlotsPromo.some(function(cs) {
                var champs = champMapPromo[cs.key] || [];
                return champs.some(function(c) { return c && String(c.wrestler_id) === String(w.wrestler_id); });
              });
              return (
                <UnifiedWrestlerCard
                  key={w.wrestler_id}
                  wrestler={w}
                  variant="preview"
                  brandColor={brandColor}
                  champions={champions}
                  roster={roster}
                  rivalries={rivalries}
                  isChampionGlow={promoIsChamp}
                  size={{ width: 143, height: 330, renderHeight: 264 }}
                />
              );
            };

            return (
              <div style={{ position: 'relative', zIndex: 2, flex: 1, display: 'flex', flexDirection: 'column' }}>
                {/* Action info bar */}
                {promoData && (
                  <div style={{ padding: '8px 16px', textAlign: 'center', borderBottom: '1px solid rgba(212,175,55,0.2)' }}>
                    <div style={{ fontFamily: "'Monda',sans-serif", fontSize: '0.62rem', color: '#d4af37', letterSpacing: '2px', textTransform: 'uppercase', marginBottom: '2px' }}>
                      {promoData.name}
                    </div>
                    <div style={{ fontFamily: "'Monda',sans-serif", fontSize: '0.44rem', color: 'rgba(255,255,255,0.35)', lineHeight: '1.4' }}>
                      {promoData.description}
                    </div>
                  </div>
                )}
                {/* Renders row */}
                <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '8px', padding: '16px' }}>
                  {/* Callers */}
                  <div style={{ display: 'flex', gap: '1px' }}>
                    {p.map(function(w, i) { return renderStar(w, 'rgba(212,175,55,0.3)', 'rgba(212,175,55,0.3)'); })}
                  </div>
                  {/* Arrow */}
                  {showArrow && (
                    <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', padding: '0 8px', flexShrink: 0 }}>
                      <span style={{ fontFamily: "'Anton',sans-serif", fontSize: '2rem', color: '#e74c3c', textShadow: '0 0 20px rgba(231,76,60,0.8)' }}>→</span>
                    </div>
                  )}
                  {/* Targets */}
                  {hasTargets && (
                    <div style={{ display: 'flex', gap: '1px' }}>
                      {promoTargets.map(function(w, i) { return renderStar(w, 'rgba(231,76,60,0.3)', 'rgba(231,76,60,0.3)'); })}
                    </div>
                  )}
                  {/* Invasion brand */}
                  {hasInvasion && (
                    <div style={{ width: '143px', height: '330px', position: 'relative', borderRadius: '8px', overflow: 'hidden', border: '2px solid ' + (promoRivalTarget.color || '#e74c3c'), background: 'rgba(0,0,0,0.4)', flexShrink: 0 }}>
                      <div style={{ height: '264px', overflow: 'hidden', position: 'relative', background: 'radial-gradient(ellipse at bottom, ' + (promoRivalTarget.color || '#e74c3c') + '22 0%, transparent 70%)' }}>
                        {GM_RENDERS_MAP[promoRivalTarget.gm]
                          ? <img loading="lazy" src={GM_RENDERS_MAP[promoRivalTarget.gm]} alt={promoRivalTarget.gm}
                              style={{ position: 'absolute', bottom: '-10%', left: '50%', transform: 'translateX(-50%)', height: '319px', width: 'auto', objectFit: 'contain', objectPosition: 'bottom' }} />
                          : <div style={{ height: '100%', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                              <div style={{ fontFamily: "'Anton',sans-serif", fontSize: '0.55rem', color: (promoRivalTarget.color || '#e74c3c') + '88', letterSpacing: '2px', textAlign: 'center', padding: '8px' }}>{promoRivalTarget.gm || '?'}</div>
                            </div>
                        }
                      </div>
                      <div style={{ position: 'absolute', bottom: 0, left: 0, right: 0, padding: '6px 8px 8px', background: 'rgba(0,0,0,0.88)', borderTop: '2px solid ' + (promoRivalTarget.color || '#e74c3c') + '66', display: 'flex', flexDirection: 'column', alignItems: 'center', gap: '3px' }}>
                        {promoRivalTarget.logo
                          ? <img loading="lazy" src={promoRivalTarget.logo} alt={promoRivalTarget.brand} style={{ height: '20px', objectFit: 'contain', filter: 'drop-shadow(0 0 4px ' + (promoRivalTarget.color || '#e74c3c') + '88)' }} onError={function(e) { e.target.style.display='none'; }} />
                          : <div style={{ fontFamily: "'Anton',sans-serif", fontSize: '0.55rem', color: promoRivalTarget.color || '#e74c3c' }}>{promoRivalTarget.brand}</div>
                        }
                        <div style={{ fontFamily: "'Monda',sans-serif", fontSize: '0.36rem', color: 'rgba(255,255,255,0.35)' }}>TARGET BRAND</div>
                      </div>
                    </div>
                  )}
                </div>
              </div>
            );
          })()}
        </div>
      ) : (
        <div style={{ flex: 1, display: 'flex', alignItems: 'center', justifyContent: 'center', ...S.mono, fontSize: '0.58rem', color: 'rgba(255,255,255,0.2)', letterSpacing: '1px' }}>
          Select a slot to book
        </div>
      )}

      {/* Special Guest Referee */}
      {slot && slot.booking && slot.booking.guestReferee && slot.booking.matchType === 'special-guest-referee' && (
        <div style={{ flexShrink: 0, padding: '8px 16px', background: 'rgba(212,175,55,0.06)', borderTop: '1px solid rgba(212,175,55,0.2)', display: 'flex', alignItems: 'center', gap: '10px' }}>
          <div style={{ fontFamily: "'Monda',sans-serif", fontSize: '0.4rem', color: '#d4af37', letterSpacing: '1px' }}>⚖ SPECIAL GUEST REFEREE</div>
          <img loading="lazy" src={getWrestlerRender(slot.booking.guestReferee) || placeholder} alt="" style={{ width: '24px', height: '32px', objectFit: 'contain', objectPosition: 'top' }} />
          <div style={{ fontFamily: "'Anton',sans-serif", fontSize: '0.52rem', color: '#d4af37' }}>{getWrestlerNameUpper(slot.booking.guestReferee, 'display')}</div>
        </div>
      )}

      {/* Interference section */}
      {slot && slot.booking && slot.booking.interference && slot.booking.interference !== 'none' && (
        <div style={{ flexShrink: 0, padding: '12px 16px', background: 'rgba(231,76,60,0.06)', borderTop: '1px solid rgba(231,76,60,0.2)' }}>
          <div style={{ fontFamily: "'Monda',sans-serif", fontSize: '0.4rem', color: '#e74c3c', letterSpacing: '2px', marginBottom: '10px', textAlign: 'center' }}>⚡ INTERFERENCE</div>
          <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '12px' }}>
            {/* Attacker card */}
            {(slot.booking.interferenceA || slot.booking.interference === 'gm') && (function() {
              var atk = slot.booking.interferenceA;
              var isGM = slot.booking.interference === 'gm';
              return (
                <div style={{ width: '80px', height: '110px', borderRadius: '6px', overflow: 'hidden', border: '1px solid rgba(231,76,60,0.5)', background: 'rgba(0,0,0,0.4)', position: 'relative', flexShrink: 0 }}>
                  <div style={{ height: '78px', overflow: 'hidden', position: 'relative', background: 'radial-gradient(ellipse at bottom, rgba(231,76,60,0.2) 0%, transparent 70%)' }}>
                    {atk && (function() {
                      var atkRender = isGM ? (GM_RENDERS_MAP[atk.name] || null) : (getWrestlerRender(atk) || null);
                      return atkRender
                        ? <img loading="lazy" src={atkRender} alt="" style={{ position: 'absolute', bottom: '-10%', left: '50%', transform: 'translateX(-50%)', height: '95px', width: 'auto', objectFit: 'contain', objectPosition: 'bottom' }} />
                        : <div style={{ height: '100%', display: 'flex', alignItems: 'center', justifyContent: 'center', fontFamily: "'Anton',sans-serif", fontSize: '0.45rem', color: '#e74c3c' }}>{atk.name || 'GM'}</div>;
                    })()}
                    {isGM && !atk && <div style={{ height: '100%', display: 'flex', alignItems: 'center', justifyContent: 'center', fontFamily: "'Anton',sans-serif", fontSize: '0.45rem', color: '#e74c3c' }}>GM</div>}
                  </div>
                  <div style={{ position: 'absolute', bottom: 0, left: 0, right: 0, padding: '3px 4px', background: 'rgba(0,0,0,0.9)', textAlign: 'center' }}>
                    <div style={{ fontFamily: "'Anton',sans-serif", fontSize: '0.38rem', color: '#fff', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>
                      {atk ? getWrestlerNameUpper(atk, 'display') : 'GM'}
                    </div>
                  </div>
                </div>
              );
            })()}
            {/* Arrow */}
            <div style={{ fontFamily: "'Anton',sans-serif", fontSize: '1.4rem', color: '#e74c3c', textShadow: '0 0 16px rgba(231,76,60,0.8)', flexShrink: 0 }}>→</div>
            {/* Target card */}
            {(function() {
              var tgt = slot.booking.interferenceB;
              if (!tgt || tgt === 'any') {
                return (
                  <div style={{ width: '80px', height: '110px', borderRadius: '6px', border: '1px dashed rgba(231,76,60,0.3)', background: 'rgba(0,0,0,0.2)', display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0 }}>
                    <div style={{ fontFamily: "'Monda',sans-serif", fontSize: '0.36rem', color: 'rgba(255,255,255,0.3)', textAlign: 'center', letterSpacing: '0.5px' }}>ANY</div>
                  </div>
                );
              }
              return (
                <div style={{ width: '80px', height: '110px', borderRadius: '6px', overflow: 'hidden', border: '1px solid rgba(231,76,60,0.4)', background: 'rgba(0,0,0,0.4)', position: 'relative', flexShrink: 0 }}>
                  <div style={{ height: '78px', overflow: 'hidden', position: 'relative', background: 'radial-gradient(ellipse at bottom, rgba(231,76,60,0.15) 0%, transparent 70%)' }}>
                    <img loading="lazy" src={getWrestlerRender(tgt) || placeholder} alt=""
                      style={{ position: 'absolute', bottom: '-10%', left: '50%', transform: 'translateX(-50%)', height: '95px', width: 'auto', objectFit: 'contain', objectPosition: 'bottom' }} />
                  </div>
                  <div style={{ position: 'absolute', bottom: 0, left: 0, right: 0, padding: '3px 4px', background: 'rgba(0,0,0,0.9)', textAlign: 'center' }}>
                    <div style={{ fontFamily: "'Anton',sans-serif", fontSize: '0.38rem', color: '#fff', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>
                      {getWrestlerNameUpper(tgt, 'display')}
                    </div>
                  </div>
                </div>
              );
            })()}
          </div>
        </div>
      )}

      {/* Bottom bar */}
      <div style={{ flexShrink: 0, paddingTop: '12px', marginTop: '8px', borderTop: '1px solid rgba(255,255,255,0.07)', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
        <div>
          {slot?.booking?.cost > 0 && (
            <>
              <div style={{ fontFamily: "'Monda',sans-serif", fontSize: '0.46rem', color: 'rgba(255,255,255,0.35)', letterSpacing: '1px' }}>MATCH COST</div>
              <div style={{ fontFamily: "'Anton',sans-serif", fontSize: '1rem', color: '#d4af37', letterSpacing: '1px' }}>${(slot?.booking?.cost || 0).toLocaleString('fr-FR')}</div>
            </>
          )}
        </div>
        {slot && (
          <div style={{ display: 'flex', gap: '8px' }}>
            {slot.booking && (
              <button onClick={onClear}
                style={{ fontFamily: "'Monda',sans-serif", fontSize: '0.62rem', letterSpacing: '1.5px', background: 'rgba(231,76,60,0.08)', border: '1px solid rgba(231,76,60,0.4)', color: 'rgba(231,76,60,0.7)', padding: '10px 18px', borderRadius: '4px', cursor: 'pointer', transition: 'background 0.15s, border-color 0.15s, color 0.15s' }}
                onMouseEnter={e => { e.currentTarget.style.background = 'rgba(231,76,60,0.18)'; e.currentTarget.style.color = '#e74c3c'; }}
                onMouseLeave={e => { e.currentTarget.style.background = 'rgba(231,76,60,0.08)'; e.currentTarget.style.color = 'rgba(231,76,60,0.7)'; }}>
                ✕ CLEAR
              </button>
            )}
            <button onClick={onEdit}
              style={{ fontFamily: "'Monda',sans-serif", fontSize: '0.62rem', letterSpacing: '1.5px', background: slot.booking ? 'rgba(212,175,55,0.1)' : 'rgba(255,255,255,0.05)', border: slot.booking ? '1px solid rgba(212,175,55,0.6)' : '1px solid rgba(255,255,255,0.35)', color: slot.booking ? '#d4af37' : '#fff', padding: '10px 24px', borderRadius: '4px', cursor: 'pointer', transition: 'background 0.15s, border-color 0.15s, color 0.15s' }}>
              {slot.booking ? (slot.type === 'promo' ? '✏ EDIT PROMO' : '✏ EDIT MATCH') : (slot.type === 'promo' ? '+ BOOK PROMO' : '+ BOOK MATCH')}
            </button>
          </div>
        )}
      </div>
    </div>
  );
};

// ── MAIN ────────────────────────────────────────────────────────────
export default function BookingPage({ gameData, brand, brandBg, onUpdateGame, onRunShow }) {
  const gmName = gameData?.gm || '';
  const brandColor = BRAND_COLORS[brand] || '#d4af37';
  const week = gameData?.week || 1;
  const difficulty = gameData?.difficulty || gameData?.gameSettingsData?.difficulty || 'normal';
  const roster = gameData?.roster || [];
  const championsData = gameData?.champions || {};
  const bookingRivalries = gameData?.rivalries || [];
  if (typeof window !== 'undefined') window._bookingRivalries = bookingRivalries;

  const isGoHome = week % 5 === 4;
  const isPLE = week % 5 === 0;
  const isWM = week === 50;

  const showType = isPLE ? (isWM ? 'WrestleMania' : 'PLE') : isGoHome ? 'Go-Home Show' : 'Weekly Show';

  // Build slots from show structure
  const structure = getShowStructure(week, difficulty) || ['opener', 'promo', 'mid', 'promo', 'mid', 'promo', 'main_event'];

  const [slots, setSlots] = useState(() => {
    const saved = gameData && gameData.bookingSlots;
    return structure.map((type, i) => ({
      id: 'slot-' + i,
      type,
      booking: (saved && saved[i] && saved[i].booking) || null,
    }));
  });

  const [selectedSlotId, setSelectedSlotId] = useState(slots[0]?.id);
  const [saveStatus, setSaveStatus] = useState(null); // null | 'saving' | 'saved'
  const [matchMakerSlotId, setMatchMakerSlotId] = useState(null);

  const selectedSlot = slots.find(s => s.id === selectedSlotId);
  const matchMakerSlot = slots.find(s => s.id === matchMakerSlotId);
  const [swapSlotId, setSwapSlotId] = useState(null);

  const handleSlotClick = (slotId) => {
    if (swapSlotId) {
      if (swapSlotId === slotId) { setSwapSlotId(null); return; }
      // Swap bookings between two slots of same type (works filled or empty)
      var slotA = slots.find(s => s.id === swapSlotId);
      var slotB = slots.find(s => s.id === slotId);
      if (slotA && slotB) {
        var updated = slots.map(s => {
          if (s.id === swapSlotId) return { ...s, booking: slotB.booking };
          if (s.id === slotId) return { ...s, booking: slotA.booking };
          return s;
        });
        setSlots(updated);
        if (onUpdateGame && gameData) onUpdateGame({ ...gameData, bookingSlots: updated });
      }
      setSwapSlotId(null);
    } else {
      setSelectedSlotId(slotId);
    }
  };

  const totalCost = slots.reduce((sum, s) => sum + (s.booking?.cost || 0), 0);
  const budget = gameData?.budget || 3000000;
  const [showBudgetEdit, setShowBudgetEdit] = useState(false);
  const [editedBudget, setEditedBudget] = useState(budget);

  const handleSaveBooking = (slotId, booking) => {
    setSlots(prev => {
      const updated = prev.map(s => s.id === slotId ? { ...s, booking } : s);
      if (onUpdateGame && gameData) onUpdateGame({ ...gameData, bookingSlots: updated });
      return updated;
    });
  };


  return (
    <div style={{ display: 'flex', flexDirection: 'column', height: '100%', gap: '12px' }}>
      <style>{css}</style>

      {/* Budget edit popup */}
      {showBudgetEdit && (
        <div style={{ position: 'fixed', inset: 0, zIndex: 800, display: 'flex', alignItems: 'center', justifyContent: 'center', background: 'rgba(0,0,0,0.7)' }}
          onClick={() => setShowBudgetEdit(false)}>
          <div style={{ background: 'rgba(8,8,8,0.97)', border: '1px solid rgba(46,204,113,0.3)', borderRadius: '12px', padding: '24px 28px', width: '320px' }}
            onClick={e => e.stopPropagation()}>
            <div style={{ fontFamily: "'Anton',sans-serif", fontSize: '0.85rem', letterSpacing: '2px', color: '#2ecc71', marginBottom: '16px' }}>ADJUST BUDGET</div>
            <input type="number" value={editedBudget} onChange={e => setEditedBudget(Number(e.target.value))}
              style={{ width: '100%', background: 'rgba(255,255,255,0.06)', border: '1px solid rgba(46,204,113,0.4)', borderRadius: '6px', padding: '10px 14px', color: '#2ecc71', fontFamily: "'Anton',sans-serif", fontSize: '1rem', outline: 'none', marginBottom: '14px', textAlign: 'center' }} />
            <div style={{ display: 'flex', gap: '8px', justifyContent: 'flex-end' }}>
              <button onClick={() => setShowBudgetEdit(false)}
                style={{ fontFamily: "'Monda',sans-serif", fontSize: '0.5rem', background: 'transparent', border: '1px solid rgba(255,255,255,0.2)', color: 'rgba(255,255,255,0.4)', padding: '7px 16px', borderRadius: '4px', cursor: 'pointer' }}>CANCEL</button>
              <button onClick={() => { if (onUpdateGame && gameData) onUpdateGame({ ...gameData, budget: editedBudget }); setShowBudgetEdit(false); }}
                style={{ fontFamily: "'Monda',sans-serif", fontSize: '0.5rem', background: 'rgba(46,204,113,0.15)', border: '1px solid rgba(46,204,113,0.5)', color: '#2ecc71', padding: '7px 16px', borderRadius: '4px', cursor: 'pointer' }}>SAVE</button>
            </div>
          </div>
        </div>
      )}
      {matchMakerSlot && (() => {
        const isCurrentPromo = matchMakerSlot.type === 'promo';
        // IDs booked in MATCHES (excluding current slot)
        const matchBookedIds = slots
          .filter(s => s.id !== matchMakerSlot.id && s.type !== 'promo' && s.booking && s.booking.participants)
          .flatMap(s => s.booking.participants.filter(Boolean).map(p => p.wrestler_id));
        // IDs booked in PROMOS (excluding current slot)
        const promoBookedIds = slots
          .filter(s => s.id !== matchMakerSlot.id && s.type === 'promo' && s.booking && s.booking.participants)
          .flatMap(s => s.booking.participants.filter(Boolean).map(p => p.wrestler_id));
        // If booking a MATCH → exclude match-booked IDs
        // If booking a PROMO → exclude promo-booked IDs
        const blockedIds = isCurrentPromo ? promoBookedIds : matchBookedIds;
        return (
          <MatchMaker
            slot={matchMakerSlot}
            roster={roster}
            champions={championsData}
            gmName={gmName}
            rivals={(gameData && gameData.rivals) || []}
            rivalries={(gameData && gameData.rivalries) || []}
            tagTeams={(gameData && gameData.tagTeams) || []}
            difficulty={difficulty}
            logistics={(gameData && gameData.logistics) || { arena: 1, crew: 1, sfx: 1, advertising: 1 }}
            matchTypeSetting={(gameData && gameData.gameSettingsData && gameData.gameSettingsData.matchType) || (gameData && gameData.matchType) || 'classic'}
            matchBookedIds={blockedIds}
            onClose={() => setMatchMakerSlotId(null)}
            brandBg={brandBg}
            brandColor={brandColor}
            currentWeek={week}
            onSave={(booking) => handleSaveBooking(matchMakerSlot.id, booking)}
          />
        );
      })()}

      {/* Header */}
      <div style={{ display: 'flex', alignItems: 'center', gap: '14px', flexShrink: 0 }}>
        <div style={{ ...S.anton, fontSize: '1.1rem', letterSpacing: '2px', color: '#fff' }}>BOOKING</div>
        <div style={{ ...S.mono, fontSize: '0.55rem', color: brandColor, letterSpacing: '1px', border: `1px solid ${brandColor}44`, borderRadius: '3px', padding: '3px 10px' }}>
          WEEK {week} — {showType.toUpperCase()}
        </div>
        <div style={{ ...S.mono, fontSize: '0.55rem', color: 'rgba(255,255,255,0.35)', letterSpacing: '1px' }}>
          {difficulty.toUpperCase()}
        </div>
        <div style={{ marginLeft: 'auto', display: 'flex', gap: '16px', alignItems: 'center' }}>
          <div style={{ textAlign: 'right' }}>
            <div style={{ ...S.mono, fontSize: '0.58rem', color: 'rgba(255,255,255,0.35)', letterSpacing: '1px' }}>FANS</div>
            <div style={{ ...S.anton, fontSize: '0.9rem', color: 'rgba(255,255,255,0.7)' }}>{((gameData?.fans) || 0).toLocaleString('fr-FR')}</div>
          </div>
          <div style={{ width: '1px', height: '32px', background: 'rgba(255,255,255,0.1)' }} />
          <div style={{ textAlign: 'right' }}>
            <div style={{ ...S.mono, fontSize: '0.58rem', color: 'rgba(255,255,255,0.35)', letterSpacing: '1px' }}>SHOW COST</div>
            <div style={{ ...S.anton, fontSize: '0.9rem', color: totalCost > budget ? '#e74c3c' : '#d4af37' }}>${totalCost.toLocaleString('fr-FR')}</div>
          </div>
          <div style={{ textAlign: 'right', cursor: 'pointer' }} onClick={() => { setEditedBudget(budget); setShowBudgetEdit(true); }}>
            <div style={{ ...S.mono, fontSize: '0.58rem', color: 'rgba(255,255,255,0.35)', letterSpacing: '1px' }}>BUDGET ✏</div>
            <div style={{ ...S.anton, fontSize: '0.9rem', color: budget < totalCost ? '#e74c3c' : '#2ecc71' }}>${budget.toLocaleString('fr-FR')}</div>
          </div>
          <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
            {saveStatus && (
              <div style={{ fontFamily: "'Monda',sans-serif", fontSize: '0.52rem', color: saveStatus === 'saved' ? '#2ecc71' : 'rgba(255,255,255,0.4)', letterSpacing: '0.5px', transition: 'color 0.3s' }}>
                {saveStatus === 'saving' ? '⏳ Saving...' : '✓ Saved!'}
              </div>
            )}
            <button className="btn-wwe"
              onClick={() => {
                if (onUpdateGame && gameData) {
                  setSaveStatus('saving');
                  onUpdateGame({ ...gameData, bookingSlots: slots });
                  setTimeout(() => setSaveStatus('saved'), 500);
                  setTimeout(() => setSaveStatus(null), 2500);
                }
              }}
              style={{ fontFamily: "'Monda',sans-serif", fontSize: '0.6rem', letterSpacing: '1.5px', background: 'rgba(46,204,113,0.1)', border: '1px solid rgba(46,204,113,0.5)', color: '#2ecc71', padding: '8px 20px', borderRadius: '4px', cursor: 'pointer', transition: 'background 0.15s, border-color 0.15s, color 0.15s' }}
              onMouseEnter={e => { e.currentTarget.style.background = 'rgba(46,204,113,0.2)'; }}
              onMouseLeave={e => { e.currentTarget.style.background = 'rgba(46,204,113,0.1)'; }}>
              💾 SAVE
            </button>

          </div>
        </div>
      </div>

      {/* Main layout */}
      <div style={{ flex: 1, display: 'grid', gridTemplateColumns: '620px 1fr', gap: '14px', minHeight: 0, overflow: 'hidden' }}>

        {/* LEFT — Slot list */}
        <div style={{ ...S.panel, padding: '14px', display: 'flex', flexDirection: 'column', gap: '8px', overflowY: 'auto' }}>
          {/* Hot rivalry suggestion */}
          {(() => {
            var hotRivalries = (bookingRivalries || []).filter(function(r) { return r.level >= 3; });
            if (hotRivalries.length === 0) return null;
            // Build set of all wrestler_ids booked in matches this week
            var matchBookedSet = new Set(
              slots
                .filter(function(s) { return s.type !== 'promo' && s.booking && s.booking.participants; })
                .flatMap(function(s) { return s.booking.participants.filter(Boolean).map(function(p) { return String(p.wrestler_id); }); })
            );
            return (
              <div style={{ padding: '8px 12px', background: 'rgba(212,175,55,0.06)', border: '1px solid rgba(212,175,55,0.25)', borderRadius: '6px', marginBottom: '8px' }}>
                <div style={{ fontFamily: "'Monda',sans-serif", fontSize: '0.42rem', color: '#d4af37', letterSpacing: '1px', marginBottom: '5px' }}>⭐ SUGGESTED MATCHES</div>
                {hotRivalries.map(function(r, i) {
                  var s1 = (r.side1 || []).map(function(id) { return (gameData && gameData.roster || []).find(function(w) { return w.wrestler_id === id || w.wrestler_id === Number(id); }); }).filter(Boolean);
                  var s2 = (r.side2 || []).map(function(id) { return (gameData && gameData.roster || []).find(function(w) { return w.wrestler_id === id || w.wrestler_id === Number(id); }); }).filter(Boolean);
                  var lvlColor = { 3: '#e74c3c', 4: '#9b59b6' }[r.level] || '#e74c3c';
                  var lvlLabel = { 3: 'Niv.3', 4: 'Niv.4 🔥' }[r.level] || '';
                  // Check if ALL members of both sides are booked in a match slot
                  var allIds = s1.concat(s2).map(function(w) { return String(w.wrestler_id); });
                  var isBooked = allIds.length > 0 && allIds.every(function(id) { return matchBookedSet.has(id); });
                  return (
                    <div key={i} style={{ display: 'flex', alignItems: 'center', gap: '8px', marginBottom: i < hotRivalries.length - 1 ? '4px' : '0', opacity: isBooked ? 0.5 : 1 }}>
                      <div style={{ fontFamily: "'Monda',sans-serif", fontSize: '0.4rem', color: isBooked ? '#2ecc71' : lvlColor, background: (isBooked ? '#2ecc71' : lvlColor) + '18', border: '1px solid ' + (isBooked ? '#2ecc71' : lvlColor) + '44', borderRadius: '3px', padding: '1px 5px', flexShrink: 0 }}>
                        {isBooked ? '✓ BOOKED' : lvlLabel}
                      </div>
                      <div style={{ fontFamily: "'Anton',sans-serif", fontSize: '0.52rem', color: isBooked ? 'rgba(255,255,255,0.4)' : '#fff', letterSpacing: '0.5px', textDecoration: isBooked ? 'line-through' : 'none' }}>
                        {s1.map(function(w) { return getWrestlerName(w, 'short'); }).join(' & ')}
                        <span style={{ color: isBooked ? 'rgba(255,255,255,0.25)' : '#e74c3c', margin: '0 5px' }}>VS</span>
                        {s2.map(function(w) { return getWrestlerName(w, 'short'); }).join(' & ')}
                      </div>
                    </div>
                  );
                })}
              </div>
            );
          })()}

          <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: '4px' }}>
            <div style={{ ...S.mono, fontSize: '0.5rem', color: 'rgba(255,255,255,0.3)', letterSpacing: '1.5px' }}>CARD</div>
            <button onClick={() => setSwapSlotId(null) || setSwapSlotId(swapSlotId ? null : 'pick')}
              style={{ ...S.mono, fontSize: '0.42rem', background: swapSlotId ? 'rgba(230,126,34,0.15)' : 'transparent', border: '1px solid ' + (swapSlotId ? 'rgba(230,126,34,0.6)' : 'rgba(255,255,255,0.15)'), color: swapSlotId ? '#e67e22' : 'rgba(255,255,255,0.4)', padding: '3px 10px', borderRadius: '3px', cursor: 'pointer' }}>
              {swapSlotId && swapSlotId !== 'pick' ? '⇄ SELECT TARGET' : '⇄ SWAP'}
            </button>
          </div>

          {/* Two-column layout: matches left, promos right */}
          <div style={{ display: 'flex', flexDirection: 'column', gap: '6px' }}>
            {slots.map((slot, i) => {
              const isMain = slot.type === 'main_event';
              return (
                <div key={slot.id} style={{ position: 'relative' }}>
                  <SlotCard
                    slot={slot}
                    isSelected={swapSlotId === slot.id || selectedSlotId === slot.id}
                    brandColor={swapSlotId === slot.id ? '#e67e22' : swapSlotId && swapSlotId !== 'pick' ? 'rgba(230,126,34,0.5)' : brandColor}
                    isMainEvent={isMain}
                    champions={championsData}
                    onClick={() => {
                      if (swapSlotId === 'pick') { setSwapSlotId(slot.id); }
                      else { handleSlotClick(slot.id); }
                    }}
                    onDoubleClick={() => { setSwapSlotId(null); setMatchMakerSlotId(slot.id); }}
                  />
                  {swapSlotId === slot.id && <div style={{ position: 'absolute', top: '4px', right: '4px', background: '#e67e22', color: '#000', fontFamily: "'Monda',sans-serif", fontSize: '0.36rem', padding: '2px 5px', borderRadius: '2px', letterSpacing: '0.5px' }}>SOURCE</div>}
                </div>
              );
            })}
          </div>
        </div>

        {/* RIGHT — Preview */}
        <div style={{ ...S.panel, padding: '16px', display: 'flex', flexDirection: 'column', overflowY: 'auto', overflowX: 'hidden', minHeight: 0 }}>
          <SlotPreview slot={selectedSlot} brandColor={brandColor} brandBg={brandBg} champions={championsData} roster={roster} rivalries={(gameData && gameData.rivalries) || []} onEdit={() => setMatchMakerSlotId(selectedSlot?.id)} onClear={() => {
              setSlots(prev => {
                const updated = prev.map(s => s.id === selectedSlotId ? { ...s, booking: null } : s);
                if (onUpdateGame && gameData) onUpdateGame({ ...gameData, bookingSlots: updated });
                return updated;
              });
            }} />
        </div>
      </div>
    </div>
  );
}
